
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5b14"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5b14"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bYoiY", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $bfWFq = parcelRequire("bfWFq");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $bfWFq.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bfWFq.default)(Rgb, rgb, (0, $bfWFq.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $bfWFq.default)(Hsl, hsl, (0, $bfWFq.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("bfWFq", function(module, exports) {

$parcel$export(module.exports, "default", () => $831e9a7deaab9d1d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $831e9a7deaab9d1d$export$8b58be045bf06082);
function $831e9a7deaab9d1d$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $831e9a7deaab9d1d$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


var $092b9decb7eceadc$exports = {};
"use strict";
Object.defineProperty($092b9decb7eceadc$exports, "__esModule", {
    value: true
});
var $092b9decb7eceadc$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $092b9decb7eceadc$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $a2eb39634a15a982$exports = {};

$parcel$defineInteropFlag($a2eb39634a15a982$exports);

$parcel$export($a2eb39634a15a982$exports, "default", () => $a2eb39634a15a982$export$2e2bcd8739ae039);
/** Keeps track of raw listeners added to the base elements to avoid duplication */ const $a2eb39634a15a982$var$ledger = new WeakMap();
function $a2eb39634a15a982$var$editLedger(wanted, baseElement, callback, setup) {
    var _a, _b;
    if (!wanted && !$a2eb39634a15a982$var$ledger.has(baseElement)) return false;
    const elementMap = (_a = $a2eb39634a15a982$var$ledger.get(baseElement)) !== null && _a !== void 0 ? _a : new WeakMap();
    $a2eb39634a15a982$var$ledger.set(baseElement, elementMap);
    if (!wanted && !$a2eb39634a15a982$var$ledger.has(baseElement)) return false;
    const setups = (_b = elementMap.get(callback)) !== null && _b !== void 0 ? _b : new Set();
    elementMap.set(callback, setups);
    const existed = setups.has(setup);
    if (wanted) setups.add(setup);
    else setups.delete(setup);
    return existed && wanted;
}
function $a2eb39634a15a982$var$isEventTarget(elements) {
    return typeof elements.addEventListener === "function";
}
function $a2eb39634a15a982$var$safeClosest(event, selector) {
    let target = event.target;
    if (target instanceof Text) target = target.parentElement;
    if (target instanceof Element && event.currentTarget instanceof Element) {
        // `.closest()` may match ancestors of `currentTarget` but we only need its children
        const closest = target.closest(selector);
        if (closest && event.currentTarget.contains(closest)) return closest;
    }
}
// This type isn't exported as a declaration, so it needs to be duplicated above
function $a2eb39634a15a982$var$delegate(base, selector, type, callback, options) {
    // Handle Selector-based usage
    if (typeof base === "string") base = document.querySelectorAll(base);
    // Handle Array-like based usage
    if (!$a2eb39634a15a982$var$isEventTarget(base)) {
        const subscriptions = Array.prototype.map.call(base, (element)=>$a2eb39634a15a982$var$delegate(element, selector, type, callback, options));
        return {
            destroy () {
                for (const subscription of subscriptions)subscription.destroy();
            }
        };
    }
    // `document` should never be the base, it's just an easy way to define "global event listeners"
    const baseElement = base instanceof Document ? base.documentElement : base;
    // Handle the regular Element usage
    const capture = Boolean(typeof options === "object" ? options.capture : options);
    const listenerFn = (event)=>{
        const delegateTarget = $a2eb39634a15a982$var$safeClosest(event, selector);
        if (delegateTarget) {
            event.delegateTarget = delegateTarget;
            callback.call(baseElement, event);
        }
    };
    // Drop unsupported `once` option https://github.com/fregante/delegate-it/pull/28#discussion_r863467939
    if (typeof options === "object") delete options.once;
    const setup = JSON.stringify({
        selector: selector,
        type: type,
        capture: capture
    });
    const isAlreadyListening = $a2eb39634a15a982$var$editLedger(true, baseElement, callback, setup);
    const delegateSubscription = {
        destroy () {
            baseElement.removeEventListener(type, listenerFn, options);
            $a2eb39634a15a982$var$editLedger(false, baseElement, callback, setup);
        }
    };
    if (!isAlreadyListening) baseElement.addEventListener(type, listenerFn, options);
    return delegateSubscription;
}
var $a2eb39634a15a982$export$2e2bcd8739ae039 = $a2eb39634a15a982$var$delegate;


var $092b9decb7eceadc$var$_delegateIt2 = $092b9decb7eceadc$var$_interopRequireDefault($a2eb39634a15a982$exports);
var $0bd69220c24ea7e4$exports = {};
"use strict";
Object.defineProperty($0bd69220c24ea7e4$exports, "__esModule", {
    value: true
});
$0bd69220c24ea7e4$exports.Cache = undefined;
var $0bd69220c24ea7e4$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $171c21fe9f651eea$exports = {};
"use strict";
Object.defineProperty($171c21fe9f651eea$exports, "__esModule", {
    value: true
});
$171c21fe9f651eea$exports.cleanupAnimationClasses = $171c21fe9f651eea$exports.Link = $171c21fe9f651eea$exports.markSwupElements = $171c21fe9f651eea$exports.normalizeUrl = $171c21fe9f651eea$exports.getCurrentUrl = $171c21fe9f651eea$exports.transitionProperty = $171c21fe9f651eea$exports.transitionEnd = $171c21fe9f651eea$exports.fetch = $171c21fe9f651eea$exports.getDataFromHtml = $171c21fe9f651eea$exports.createHistoryRecord = $171c21fe9f651eea$exports.classify = undefined;
var $67f68cb7c26f5d9e$exports = {};
"use strict";
Object.defineProperty($67f68cb7c26f5d9e$exports, "__esModule", {
    value: true
});
var $67f68cb7c26f5d9e$var$classify = function classify(text) {
    var output = text.toString().toLowerCase().replace(/\s+/g, "-") // Replace spaces with -
    .replace(/\//g, "-") // Replace / with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text
    if (output[0] === "/") output = output.splice(1);
    if (output === "") output = "homepage";
    return output;
};
$67f68cb7c26f5d9e$exports.default = $67f68cb7c26f5d9e$var$classify;


var $171c21fe9f651eea$var$_classify2 = $171c21fe9f651eea$var$_interopRequireDefault($67f68cb7c26f5d9e$exports);
var $a932fcef7360948d$exports = {};
"use strict";
Object.defineProperty($a932fcef7360948d$exports, "__esModule", {
    value: true
});
var $a932fcef7360948d$var$createHistoryRecord = function createHistoryRecord(url) {
    window.history.pushState({
        url: url || window.location.href.split(window.location.hostname)[1],
        random: Math.random(),
        source: "swup"
    }, document.title, url || window.location.href.split(window.location.hostname)[1]);
};
$a932fcef7360948d$exports.default = $a932fcef7360948d$var$createHistoryRecord;


var $171c21fe9f651eea$var$_createHistoryRecord2 = $171c21fe9f651eea$var$_interopRequireDefault($a932fcef7360948d$exports);
var $2f01663db8d5bccf$exports = {};
"use strict";
Object.defineProperty($2f01663db8d5bccf$exports, "__esModule", {
    value: true
});
var $ec852511eb946064$exports = {};
"use strict";
Object.defineProperty($ec852511eb946064$exports, "__esModule", {
    value: true
});
var $ec852511eb946064$var$query = $ec852511eb946064$exports.query = function query(selector) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
    if (typeof selector !== "string") return selector;
    return context.querySelector(selector);
};
var $ec852511eb946064$var$queryAll = $ec852511eb946064$exports.queryAll = function queryAll(selector) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
    if (typeof selector !== "string") return selector;
    return Array.prototype.slice.call(context.querySelectorAll(selector));
};
var $ec852511eb946064$var$escapeCssIdentifier = $ec852511eb946064$exports.escapeCssIdentifier = function escapeCssIdentifier(ident) {
    if (window.CSS && window.CSS.escape) return CSS.escape(ident);
    else return ident;
};


var $2f01663db8d5bccf$var$getDataFromHtml = function getDataFromHtml(html, containers) {
    var fakeDom = document.createElement("html");
    fakeDom.innerHTML = html;
    var blocks = [];
    containers.forEach(function(selector) {
        if ((0, $ec852511eb946064$exports.query)(selector, fakeDom) == null) {
            console.warn("[swup] Container " + selector + " not found on page.");
            return null;
        } else {
            if ((0, $ec852511eb946064$exports.queryAll)(selector).length !== (0, $ec852511eb946064$exports.queryAll)(selector, fakeDom).length) console.warn("[swup] Mismatched number of containers found on new page.");
            (0, $ec852511eb946064$exports.queryAll)(selector).forEach(function(item, index) {
                (0, $ec852511eb946064$exports.queryAll)(selector, fakeDom)[index].setAttribute("data-swup", blocks.length);
                blocks.push((0, $ec852511eb946064$exports.queryAll)(selector, fakeDom)[index].outerHTML);
            });
        }
    });
    var json = {
        title: (fakeDom.querySelector("title") || {}).innerText,
        pageClass: fakeDom.querySelector("body").className,
        originalContent: html,
        blocks: blocks
    };
    // to prevent memory leaks
    fakeDom.innerHTML = "";
    fakeDom = null;
    return json;
};
$2f01663db8d5bccf$exports.default = $2f01663db8d5bccf$var$getDataFromHtml;


var $171c21fe9f651eea$var$_getDataFromHtml2 = $171c21fe9f651eea$var$_interopRequireDefault($2f01663db8d5bccf$exports);
var $3a0afaa937801dd6$exports = {};
"use strict";
Object.defineProperty($3a0afaa937801dd6$exports, "__esModule", {
    value: true
});
var $3a0afaa937801dd6$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $3a0afaa937801dd6$var$fetch = function fetch(setOptions) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var defaults = {
        url: window.location.pathname + window.location.search,
        method: "GET",
        data: null,
        headers: {}
    };
    var options = $3a0afaa937801dd6$var$_extends({}, defaults, setOptions);
    var request = new XMLHttpRequest();
    request.onreadystatechange = function() {
        if (request.readyState === 4) {
            if (request.status !== 500) callback(request);
            else callback(request);
        }
    };
    request.open(options.method, options.url, true);
    Object.keys(options.headers).forEach(function(key) {
        request.setRequestHeader(key, options.headers[key]);
    });
    request.send(options.data);
    return request;
};
$3a0afaa937801dd6$exports.default = $3a0afaa937801dd6$var$fetch;


var $171c21fe9f651eea$var$_fetch2 = $171c21fe9f651eea$var$_interopRequireDefault($3a0afaa937801dd6$exports);
var $5c515894dd3a064b$exports = {};
"use strict";
Object.defineProperty($5c515894dd3a064b$exports, "__esModule", {
    value: true
});
var $5c515894dd3a064b$var$transitionEnd = function transitionEnd() {
    if (window.ontransitionend === undefined && window.onwebkittransitionend !== undefined) return "webkitTransitionEnd";
    else return "transitionend";
};
$5c515894dd3a064b$exports.default = $5c515894dd3a064b$var$transitionEnd;


var $171c21fe9f651eea$var$_transitionEnd2 = $171c21fe9f651eea$var$_interopRequireDefault($5c515894dd3a064b$exports);
var $bf333c64cfa755f2$exports = {};
"use strict";
Object.defineProperty($bf333c64cfa755f2$exports, "__esModule", {
    value: true
});
var $bf333c64cfa755f2$var$transitionProperty = function transitionProperty() {
    if (window.ontransitionend === undefined && window.onwebkittransitionend !== undefined) return "WebkitTransition";
    else return "transition";
};
$bf333c64cfa755f2$exports.default = $bf333c64cfa755f2$var$transitionProperty;


var $171c21fe9f651eea$var$_transitionProperty2 = $171c21fe9f651eea$var$_interopRequireDefault($bf333c64cfa755f2$exports);
var $85d6577cd0532c32$exports = {};
"use strict";
Object.defineProperty($85d6577cd0532c32$exports, "__esModule", {
    value: true
});
var $85d6577cd0532c32$var$getCurrentUrl = function getCurrentUrl() {
    return window.location.pathname + window.location.search;
};
$85d6577cd0532c32$exports.default = $85d6577cd0532c32$var$getCurrentUrl;


var $171c21fe9f651eea$var$_getCurrentUrl2 = $171c21fe9f651eea$var$_interopRequireDefault($85d6577cd0532c32$exports);
var $47f19f192d208b6b$exports = {};
"use strict";
Object.defineProperty($47f19f192d208b6b$exports, "__esModule", {
    value: true
});
var $0b5441a22b5b2af9$exports = {};
"use strict";
Object.defineProperty($0b5441a22b5b2af9$exports, "__esModule", {
    value: true
});
var $0b5441a22b5b2af9$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $0b5441a22b5b2af9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $0b5441a22b5b2af9$var$Link = function() {
    function Link(elementOrUrl) {
        $0b5441a22b5b2af9$var$_classCallCheck(this, Link);
        if (elementOrUrl instanceof Element || elementOrUrl instanceof SVGElement) this.link = elementOrUrl;
        else {
            this.link = document.createElement("a");
            this.link.href = elementOrUrl;
        }
    }
    $0b5441a22b5b2af9$var$_createClass(Link, [
        {
            key: "getPath",
            value: function getPath() {
                var path = this.link.pathname;
                if (path[0] !== "/") path = "/" + path;
                return path;
            }
        },
        {
            key: "getAddress",
            value: function getAddress() {
                var path = this.link.pathname + this.link.search;
                if (this.link.getAttribute("xlink:href")) path = this.link.getAttribute("xlink:href");
                if (path[0] !== "/") path = "/" + path;
                return path;
            }
        },
        {
            key: "getHash",
            value: function getHash() {
                return this.link.hash;
            }
        }
    ]);
    return Link;
}();
$0b5441a22b5b2af9$exports.default = $0b5441a22b5b2af9$var$Link;


var $47f19f192d208b6b$var$_Link2 = $47f19f192d208b6b$var$_interopRequireDefault($0b5441a22b5b2af9$exports);
function $47f19f192d208b6b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $47f19f192d208b6b$var$normalizeUrl = function normalizeUrl(url) {
    return new $47f19f192d208b6b$var$_Link2.default(url).getAddress();
};
$47f19f192d208b6b$exports.default = $47f19f192d208b6b$var$normalizeUrl;


var $171c21fe9f651eea$var$_normalizeUrl2 = $171c21fe9f651eea$var$_interopRequireDefault($47f19f192d208b6b$exports);
var $4702b87bac54cf7d$exports = {};
"use strict";
Object.defineProperty($4702b87bac54cf7d$exports, "__esModule", {
    value: true
});

var $4702b87bac54cf7d$var$markSwupElements = function markSwupElements(element, containers) {
    var blocks = 0;
    containers.forEach(function(selector) {
        if ((0, $ec852511eb946064$exports.query)(selector, element) == null) console.warn("[swup] Container " + selector + " not found on page.");
        else (0, $ec852511eb946064$exports.queryAll)(selector).forEach(function(item, index) {
            (0, $ec852511eb946064$exports.queryAll)(selector, element)[index].setAttribute("data-swup", blocks);
            blocks++;
        });
    });
};
$4702b87bac54cf7d$exports.default = $4702b87bac54cf7d$var$markSwupElements;


var $171c21fe9f651eea$var$_markSwupElements2 = $171c21fe9f651eea$var$_interopRequireDefault($4702b87bac54cf7d$exports);

var $171c21fe9f651eea$var$_Link2 = $171c21fe9f651eea$var$_interopRequireDefault($0b5441a22b5b2af9$exports);
var $5683bf018526ea36$exports = {};
"use strict";
Object.defineProperty($5683bf018526ea36$exports, "__esModule", {
    value: true
});
var $5683bf018526ea36$var$cleanupAnimationClasses = function cleanupAnimationClasses() {
    document.documentElement.className.split(" ").forEach(function(classItem) {
        if (// remove "to-{page}" classes
        new RegExp("^to-").test(classItem) || // remove all other classes
        classItem === "is-changing" || classItem === "is-rendering" || classItem === "is-popstate") document.documentElement.classList.remove(classItem);
    });
};
$5683bf018526ea36$exports.default = $5683bf018526ea36$var$cleanupAnimationClasses;


var $171c21fe9f651eea$var$_cleanupAnimationClasses2 = $171c21fe9f651eea$var$_interopRequireDefault($5683bf018526ea36$exports);
function $171c21fe9f651eea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $171c21fe9f651eea$var$classify = $171c21fe9f651eea$exports.classify = $171c21fe9f651eea$var$_classify2.default;
var $171c21fe9f651eea$var$createHistoryRecord = $171c21fe9f651eea$exports.createHistoryRecord = $171c21fe9f651eea$var$_createHistoryRecord2.default;
var $171c21fe9f651eea$var$getDataFromHtml = $171c21fe9f651eea$exports.getDataFromHtml = $171c21fe9f651eea$var$_getDataFromHtml2.default;
var $171c21fe9f651eea$var$fetch = $171c21fe9f651eea$exports.fetch = $171c21fe9f651eea$var$_fetch2.default;
var $171c21fe9f651eea$var$transitionEnd = $171c21fe9f651eea$exports.transitionEnd = $171c21fe9f651eea$var$_transitionEnd2.default;
var $171c21fe9f651eea$var$transitionProperty = $171c21fe9f651eea$exports.transitionProperty = $171c21fe9f651eea$var$_transitionProperty2.default;
var $171c21fe9f651eea$var$getCurrentUrl = $171c21fe9f651eea$exports.getCurrentUrl = $171c21fe9f651eea$var$_getCurrentUrl2.default;
var $171c21fe9f651eea$var$normalizeUrl = $171c21fe9f651eea$exports.normalizeUrl = $171c21fe9f651eea$var$_normalizeUrl2.default;
var $171c21fe9f651eea$var$markSwupElements = $171c21fe9f651eea$exports.markSwupElements = $171c21fe9f651eea$var$_markSwupElements2.default;
var $171c21fe9f651eea$var$Link = $171c21fe9f651eea$exports.Link = $171c21fe9f651eea$var$_Link2.default;
var $171c21fe9f651eea$var$cleanupAnimationClasses = $171c21fe9f651eea$exports.cleanupAnimationClasses = $171c21fe9f651eea$var$_cleanupAnimationClasses2.default;


function $0bd69220c24ea7e4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $0bd69220c24ea7e4$var$Cache = $0bd69220c24ea7e4$exports.Cache = function() {
    function Cache() {
        $0bd69220c24ea7e4$var$_classCallCheck(this, Cache);
        this.pages = {};
        this.last = null;
    }
    $0bd69220c24ea7e4$var$_createClass(Cache, [
        {
            key: "cacheUrl",
            value: function cacheUrl(page) {
                page.url = (0, $171c21fe9f651eea$exports.normalizeUrl)(page.url);
                if (page.url in this.pages === false) this.pages[page.url] = page;
                this.last = this.pages[page.url];
                this.swup.log("Cache (" + Object.keys(this.pages).length + ")", this.pages);
            }
        },
        {
            key: "getPage",
            value: function getPage(url) {
                url = (0, $171c21fe9f651eea$exports.normalizeUrl)(url);
                return this.pages[url];
            }
        },
        {
            key: "getCurrentPage",
            value: function getCurrentPage() {
                return this.getPage((0, $171c21fe9f651eea$exports.getCurrentUrl)());
            }
        },
        {
            key: "exists",
            value: function exists(url) {
                url = (0, $171c21fe9f651eea$exports.normalizeUrl)(url);
                return url in this.pages;
            }
        },
        {
            key: "empty",
            value: function empty() {
                this.pages = {};
                this.last = null;
                this.swup.log("Cache cleared");
            }
        },
        {
            key: "remove",
            value: function remove(url) {
                delete this.pages[url];
            }
        }
    ]);
    return Cache;
}();
$0bd69220c24ea7e4$exports.default = $0bd69220c24ea7e4$var$Cache;


var $092b9decb7eceadc$var$_Cache2 = $092b9decb7eceadc$var$_interopRequireDefault($0bd69220c24ea7e4$exports);
var $344c5e365ba3a56b$exports = {};
"use strict";
Object.defineProperty($344c5e365ba3a56b$exports, "__esModule", {
    value: true
});
var $344c5e365ba3a56b$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $344c5e365ba3a56b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $344c5e365ba3a56b$var$loadPage = function loadPage(data, popstate) {
    var _this = this;
    // create array for storing animation promises
    var animationPromises = [], xhrPromise = void 0;
    var animateOut = function animateOut() {
        _this.triggerEvent("animationOutStart");
        // handle classes
        document.documentElement.classList.add("is-changing");
        document.documentElement.classList.add("is-leaving");
        document.documentElement.classList.add("is-animating");
        if (popstate) document.documentElement.classList.add("is-popstate");
        document.documentElement.classList.add("to-" + (0, $171c21fe9f651eea$exports.classify)(data.url));
        // animation promise stuff
        animationPromises = _this.getAnimationPromises("out");
        Promise.all(animationPromises).then(function() {
            _this.triggerEvent("animationOutDone");
        });
        // create history record if this is not a popstate call
        if (!popstate) {
            // create pop element with or without anchor
            var state = void 0;
            if (_this.scrollToElement != null) state = data.url + _this.scrollToElement;
            else state = data.url;
            (0, $171c21fe9f651eea$exports.createHistoryRecord)(state);
        }
    };
    this.triggerEvent("transitionStart", popstate);
    // set transition object
    if (data.customTransition != null) {
        this.updateTransition(window.location.pathname, data.url, data.customTransition);
        document.documentElement.classList.add("to-" + (0, $171c21fe9f651eea$exports.classify)(data.customTransition));
    } else this.updateTransition(window.location.pathname, data.url);
    // start/skip animation
    if (!popstate || this.options.animateHistoryBrowsing) animateOut();
    else this.triggerEvent("animationSkipped");
    // start/skip loading of page
    if (this.cache.exists(data.url)) {
        xhrPromise = new Promise(function(resolve) {
            resolve(_this.cache.getPage(data.url));
        });
        this.triggerEvent("pageRetrievedFromCache");
    } else if (!this.preloadPromise || this.preloadPromise.route != data.url) xhrPromise = new Promise(function(resolve, reject) {
        (0, $171c21fe9f651eea$exports.fetch)($344c5e365ba3a56b$var$_extends({}, data, {
            headers: _this.options.requestHeaders
        }), function(response) {
            if (response.status === 500) {
                _this.triggerEvent("serverError");
                reject(data.url);
                return;
            } else {
                // get json data
                var page = _this.getPageData(response);
                if (page != null && page.blocks.length > 0) page.url = data.url;
                else {
                    reject(data.url);
                    return;
                }
                // render page
                _this.cache.cacheUrl(page);
                _this.triggerEvent("pageLoaded");
                resolve(page);
            }
        });
    });
    else xhrPromise = this.preloadPromise;
    // when everything is ready, handle the outcome
    Promise.all([
        xhrPromise
    ].concat(animationPromises)).then(function(_ref) {
        var _ref2 = $344c5e365ba3a56b$var$_slicedToArray(_ref, 1), pageData = _ref2[0];
        // render page
        _this.renderPage(pageData, popstate);
        _this.preloadPromise = null;
    }).catch(function(errorUrl) {
        // rewrite the skipPopStateHandling function to redirect manually when the history.go is processed
        _this.options.skipPopStateHandling = function() {
            window.location = errorUrl;
            return true;
        };
        // go back to the actual page were still at
        window.history.go(-1);
    });
};
$344c5e365ba3a56b$exports.default = $344c5e365ba3a56b$var$loadPage;


var $092b9decb7eceadc$var$_loadPage2 = $092b9decb7eceadc$var$_interopRequireDefault($344c5e365ba3a56b$exports);
var $0b608755624c347c$exports = {};
"use strict";
Object.defineProperty($0b608755624c347c$exports, "__esModule", {
    value: true
});
var $0b608755624c347c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $0b608755624c347c$var$renderPage = function renderPage(page, popstate) {
    var _this = this;
    document.documentElement.classList.remove("is-leaving");
    var isCurrentPage = this.getCurrentUrl() === page.url;
    if (!isCurrentPage) return;
    // replace state in case the url was redirected
    var url = new $171c21fe9f651eea$exports.Link(page.responseURL).getPath();
    if (window.location.pathname !== url) {
        window.history.replaceState({
            url: url,
            random: Math.random(),
            source: "swup"
        }, document.title, url);
        // save new record for redirected url
        this.cache.cacheUrl($0b608755624c347c$var$_extends({}, page, {
            url: url
        }));
    }
    // only add for non-popstate transitions
    if (!popstate || this.options.animateHistoryBrowsing) document.documentElement.classList.add("is-rendering");
    this.triggerEvent("willReplaceContent", popstate);
    // replace blocks
    for(var i = 0; i < page.blocks.length; i++)document.body.querySelector('[data-swup="' + i + '"]').outerHTML = page.blocks[i];
    // set title
    document.title = page.title;
    this.triggerEvent("contentReplaced", popstate);
    this.triggerEvent("pageView", popstate);
    // empty cache if it's disabled (because pages could be preloaded and stuff)
    if (!this.options.cache) this.cache.empty();
    // start animation IN
    setTimeout(function() {
        if (!popstate || _this.options.animateHistoryBrowsing) {
            _this.triggerEvent("animationInStart");
            document.documentElement.classList.remove("is-animating");
        }
    }, 10);
    // handle end of animation
    if (!popstate || this.options.animateHistoryBrowsing) {
        var animationPromises = this.getAnimationPromises("in");
        Promise.all(animationPromises).then(function() {
            _this.triggerEvent("animationInDone");
            _this.triggerEvent("transitionEnd", popstate);
            _this.cleanupAnimationClasses();
        });
    } else this.triggerEvent("transitionEnd", popstate);
    // reset scroll-to element
    this.scrollToElement = null;
};
$0b608755624c347c$exports.default = $0b608755624c347c$var$renderPage;


var $092b9decb7eceadc$var$_renderPage2 = $092b9decb7eceadc$var$_interopRequireDefault($0b608755624c347c$exports);
var $70614b6f77af69e9$exports = {};
"use strict";
Object.defineProperty($70614b6f77af69e9$exports, "__esModule", {
    value: true
});
var $70614b6f77af69e9$var$triggerEvent = function triggerEvent(eventName, originalEvent) {
    // call saved handlers with "on" method and pass originalEvent object if available
    this._handlers[eventName].forEach(function(handler) {
        try {
            handler(originalEvent);
        } catch (error) {
            console.error(error);
        }
    });
    // trigger event on document with prefix "swup:"
    var event = new CustomEvent("swup:" + eventName, {
        detail: eventName
    });
    document.dispatchEvent(event);
};
$70614b6f77af69e9$exports.default = $70614b6f77af69e9$var$triggerEvent;


var $092b9decb7eceadc$var$_triggerEvent2 = $092b9decb7eceadc$var$_interopRequireDefault($70614b6f77af69e9$exports);
var $05e115c44ff83a64$exports = {};
"use strict";
Object.defineProperty($05e115c44ff83a64$exports, "__esModule", {
    value: true
});
var $05e115c44ff83a64$var$on = function on(event, handler) {
    if (this._handlers[event]) this._handlers[event].push(handler);
    else console.warn("Unsupported event " + event + ".");
};
$05e115c44ff83a64$exports.default = $05e115c44ff83a64$var$on;


var $092b9decb7eceadc$var$_on2 = $092b9decb7eceadc$var$_interopRequireDefault($05e115c44ff83a64$exports);
var $d61f8e002fd29234$exports = {};
"use strict";
Object.defineProperty($d61f8e002fd29234$exports, "__esModule", {
    value: true
});
var $d61f8e002fd29234$var$off = function off(event, handler) {
    var _this = this;
    if (event != null) {
        if (handler != null) {
            if (this._handlers[event] && this._handlers[event].filter(function(savedHandler) {
                return savedHandler === handler;
            }).length) {
                var toRemove = this._handlers[event].filter(function(savedHandler) {
                    return savedHandler === handler;
                })[0];
                var index = this._handlers[event].indexOf(toRemove);
                if (index > -1) this._handlers[event].splice(index, 1);
            } else console.warn("Handler for event '" + event + "' no found.");
        } else this._handlers[event] = [];
    } else Object.keys(this._handlers).forEach(function(keys) {
        _this._handlers[keys] = [];
    });
};
$d61f8e002fd29234$exports.default = $d61f8e002fd29234$var$off;


var $092b9decb7eceadc$var$_off2 = $092b9decb7eceadc$var$_interopRequireDefault($d61f8e002fd29234$exports);
var $dd3066e5a7bb8dd5$exports = {};
"use strict";
Object.defineProperty($dd3066e5a7bb8dd5$exports, "__esModule", {
    value: true
});
var $dd3066e5a7bb8dd5$var$updateTransition = function updateTransition(from, to, custom) {
    // transition routes
    this.transition = {
        from: from,
        to: to,
        custom: custom
    };
};
$dd3066e5a7bb8dd5$exports.default = $dd3066e5a7bb8dd5$var$updateTransition;


var $092b9decb7eceadc$var$_updateTransition2 = $092b9decb7eceadc$var$_interopRequireDefault($dd3066e5a7bb8dd5$exports);
var $1db2406602b65c99$exports = {};
"use strict";
Object.defineProperty($1db2406602b65c99$exports, "__esModule", {
    value: true
});

var $1db2406602b65c99$var$getAnchorElement = function getAnchorElement(hash) {
    if (!hash) return null;
    if (hash.charAt(0) === "#") hash = hash.substring(1);
    hash = decodeURIComponent(hash);
    hash = (0, $ec852511eb946064$exports.escapeCssIdentifier)(hash);
    // https://html.spec.whatwg.org/#find-a-potential-indicated-element
    return (0, $ec852511eb946064$exports.query)("#" + hash) || (0, $ec852511eb946064$exports.query)("a[name='" + hash + "']");
};
$1db2406602b65c99$exports.default = $1db2406602b65c99$var$getAnchorElement;


var $092b9decb7eceadc$var$_getAnchorElement2 = $092b9decb7eceadc$var$_interopRequireDefault($1db2406602b65c99$exports);
var $f69a24ec9a770b04$exports = {};
"use strict";
Object.defineProperty($f69a24ec9a770b04$exports, "__esModule", {
    value: true
});


var $f69a24ec9a770b04$var$getAnimationPromises = function getAnimationPromises() {
    var selector = this.options.animationSelector;
    var durationProperty = (0, $171c21fe9f651eea$exports.transitionProperty)() + "Duration";
    var promises = [];
    var animatedElements = (0, $ec852511eb946064$exports.queryAll)(selector, document.body);
    if (!animatedElements.length) {
        console.warn("[swup] No animated elements found by selector " + selector);
        return [
            Promise.resolve()
        ];
    }
    animatedElements.forEach(function(element) {
        var transitionDuration = window.getComputedStyle(element)[durationProperty];
        // Resolve immediately if no transition defined
        if (!transitionDuration || transitionDuration == "0s") {
            console.warn("[swup] No CSS transition duration defined for element of selector " + selector);
            promises.push(Promise.resolve());
            return;
        }
        var promise = new Promise(function(resolve) {
            element.addEventListener((0, $171c21fe9f651eea$exports.transitionEnd)(), function(event) {
                if (element == event.target) resolve();
            });
        });
        promises.push(promise);
    });
    return promises;
};
$f69a24ec9a770b04$exports.default = $f69a24ec9a770b04$var$getAnimationPromises;


var $092b9decb7eceadc$var$_getAnimationPromises2 = $092b9decb7eceadc$var$_interopRequireDefault($f69a24ec9a770b04$exports);
var $a5436077d088ffd2$exports = {};
"use strict";
Object.defineProperty($a5436077d088ffd2$exports, "__esModule", {
    value: true
});

var $a5436077d088ffd2$var$getPageData = function getPageData(request) {
    // this method can be replaced in case other content than html is expected to be received from server
    // this function should always return {title, pageClass, originalContent, blocks, responseURL}
    // in case page has invalid structure - return null
    var html = request.responseText;
    var pageObject = (0, $171c21fe9f651eea$exports.getDataFromHtml)(html, this.options.containers);
    if (pageObject) pageObject.responseURL = request.responseURL ? request.responseURL : window.location.href;
    else {
        console.warn("[swup] Received page is invalid.");
        return null;
    }
    return pageObject;
};
$a5436077d088ffd2$exports.default = $a5436077d088ffd2$var$getPageData;


var $092b9decb7eceadc$var$_getPageData2 = $092b9decb7eceadc$var$_interopRequireDefault($a5436077d088ffd2$exports);
var $4ee9f64f581d6e18$exports = {};
"use strict";
Object.defineProperty($4ee9f64f581d6e18$exports, "__esModule", {
    value: true
});
var $4ee9f64f581d6e18$var$use = $4ee9f64f581d6e18$exports.use = function use(plugin) {
    if (!plugin.isSwupPlugin) {
        console.warn("Not swup plugin instance " + plugin + ".");
        return;
    }
    this.plugins.push(plugin);
    plugin.swup = this;
    if (typeof plugin._beforeMount === "function") plugin._beforeMount();
    plugin.mount();
    return this.plugins;
};
var $4ee9f64f581d6e18$var$unuse = $4ee9f64f581d6e18$exports.unuse = function unuse(plugin) {
    var pluginReference = void 0;
    if (typeof plugin === "string") pluginReference = this.plugins.find(function(p) {
        return plugin === p.name;
    });
    else pluginReference = plugin;
    if (!pluginReference) {
        console.warn("No such plugin.");
        return;
    }
    pluginReference.unmount();
    if (typeof pluginReference._afterUnmount === "function") pluginReference._afterUnmount();
    var index = this.plugins.indexOf(pluginReference);
    this.plugins.splice(index, 1);
    return this.plugins;
};
var $4ee9f64f581d6e18$var$findPlugin = $4ee9f64f581d6e18$exports.findPlugin = function findPlugin(pluginName) {
    return this.plugins.find(function(p) {
        return pluginName === p.name;
    });
};




function $092b9decb7eceadc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $092b9decb7eceadc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $092b9decb7eceadc$var$Swup = function() {
    function Swup(setOptions) {
        $092b9decb7eceadc$var$_classCallCheck(this, Swup);
        // default options
        var defaults = {
            animateHistoryBrowsing: false,
            animationSelector: '[class*="transition-"]',
            linkSelector: 'a[href^="' + window.location.origin + '"]:not([data-no-swup]), a[href^="/"]:not([data-no-swup]), a[href^="#"]:not([data-no-swup])',
            cache: true,
            containers: [
                "#swup"
            ],
            requestHeaders: {
                "X-Requested-With": "swup",
                Accept: "text/html, application/xhtml+xml"
            },
            plugins: [],
            skipPopStateHandling: function skipPopStateHandling(event) {
                return !(event.state && event.state.source === "swup");
            }
        };
        // merge options
        var options = $092b9decb7eceadc$var$_extends({}, defaults, setOptions);
        // handler arrays
        this._handlers = {
            animationInDone: [],
            animationInStart: [],
            animationOutDone: [],
            animationOutStart: [],
            animationSkipped: [],
            clickLink: [],
            contentReplaced: [],
            disabled: [],
            enabled: [],
            openPageInNewTab: [],
            pageLoaded: [],
            pageRetrievedFromCache: [],
            pageView: [],
            popState: [],
            samePage: [],
            samePageWithHash: [],
            serverError: [],
            transitionStart: [],
            transitionEnd: [],
            willReplaceContent: []
        };
        // variable for anchor to scroll to after render
        this.scrollToElement = null;
        // variable for promise used for preload, so no new loading of the same page starts while page is loading
        this.preloadPromise = null;
        // variable for save options
        this.options = options;
        // variable for plugins array
        this.plugins = [];
        // variable for current transition object
        this.transition = {};
        // variable for keeping event listeners from "delegate"
        this.delegatedListeners = {};
        // so we are able to remove the listener
        this.boundPopStateHandler = this.popStateHandler.bind(this);
        // make modules accessible in instance
        this.cache = new $092b9decb7eceadc$var$_Cache2.default();
        this.cache.swup = this;
        this.loadPage = $092b9decb7eceadc$var$_loadPage2.default;
        this.renderPage = $092b9decb7eceadc$var$_renderPage2.default;
        this.triggerEvent = $092b9decb7eceadc$var$_triggerEvent2.default;
        this.on = $092b9decb7eceadc$var$_on2.default;
        this.off = $092b9decb7eceadc$var$_off2.default;
        this.updateTransition = $092b9decb7eceadc$var$_updateTransition2.default;
        this.getAnimationPromises = $092b9decb7eceadc$var$_getAnimationPromises2.default;
        this.getPageData = $092b9decb7eceadc$var$_getPageData2.default;
        this.getAnchorElement = $092b9decb7eceadc$var$_getAnchorElement2.default;
        this.log = function() {}; // here so it can be used by plugins
        this.use = $4ee9f64f581d6e18$exports.use;
        this.unuse = $4ee9f64f581d6e18$exports.unuse;
        this.findPlugin = $4ee9f64f581d6e18$exports.findPlugin;
        this.getCurrentUrl = $171c21fe9f651eea$exports.getCurrentUrl;
        this.cleanupAnimationClasses = $171c21fe9f651eea$exports.cleanupAnimationClasses;
        // enable swup
        this.enable();
    }
    $092b9decb7eceadc$var$_createClass(Swup, [
        {
            key: "enable",
            value: function enable() {
                var _this = this;
                // check for Promise support
                if (typeof Promise === "undefined") {
                    console.warn("Promise is not supported");
                    return;
                }
                // add event listeners
                this.delegatedListeners.click = (0, $092b9decb7eceadc$var$_delegateIt2.default)(document, this.options.linkSelector, "click", this.linkClickHandler.bind(this));
                window.addEventListener("popstate", this.boundPopStateHandler);
                // initial save to cache
                this.options.cache;
                // disabled to avoid caching modified dom state
                // https://github.com/swup/swup/issues/475
                // logic moved to preload plugin
                // mark swup blocks in html
                (0, $171c21fe9f651eea$exports.markSwupElements)(document.documentElement, this.options.containers);
                // mount plugins
                this.options.plugins.forEach(function(plugin) {
                    _this.use(plugin);
                });
                // modify initial history record
                window.history.replaceState(Object.assign({}, window.history.state, {
                    url: window.location.href,
                    random: Math.random(),
                    source: "swup"
                }), document.title, window.location.href);
                // trigger enabled event
                this.triggerEvent("enabled");
                // add swup-enabled class to html tag
                document.documentElement.classList.add("swup-enabled");
                // trigger page view event
                this.triggerEvent("pageView");
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this2 = this;
                // remove delegated listeners
                this.delegatedListeners.click.destroy();
                // remove popstate listener
                window.removeEventListener("popstate", this.boundPopStateHandler);
                // empty cache
                this.cache.empty();
                // unmount plugins
                this.options.plugins.forEach(function(plugin) {
                    _this2.unuse(plugin);
                });
                // remove swup data atributes from blocks
                (0, $ec852511eb946064$exports.queryAll)("[data-swup]").forEach(function(element) {
                    element.removeAttribute("data-swup");
                });
                // remove handlers
                this.off();
                // trigger disable event
                this.triggerEvent("disabled");
                // remove swup-enabled class from html tag
                document.documentElement.classList.remove("swup-enabled");
            }
        },
        {
            key: "linkClickHandler",
            value: function linkClickHandler(event) {
                // no control key pressed
                if (!event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) // index of pressed button needs to be checked because Firefox triggers click on all mouse buttons
                {
                    if (event.button === 0) {
                        this.triggerEvent("clickLink", event);
                        event.preventDefault();
                        var link = new $171c21fe9f651eea$exports.Link(event.delegateTarget);
                        if (link.getAddress() == (0, $171c21fe9f651eea$exports.getCurrentUrl)() || link.getAddress() == "") {
                            // link to the same URL
                            if (link.getHash() != "") {
                                // link to the same URL with hash
                                this.triggerEvent("samePageWithHash", event);
                                var element = (0, $092b9decb7eceadc$var$_getAnchorElement2.default)(link.getHash());
                                if (element != null) history.replaceState({
                                    url: link.getAddress() + link.getHash(),
                                    random: Math.random(),
                                    source: "swup"
                                }, document.title, link.getAddress() + link.getHash());
                                else // referenced element not found
                                console.warn("Element for offset not found (" + link.getHash() + ")");
                            } else // link to the same URL without hash
                            this.triggerEvent("samePage", event);
                        } else {
                            // link to different url
                            if (link.getHash() != "") this.scrollToElement = link.getHash();
                            // get custom transition from data
                            var customTransition = event.delegateTarget.getAttribute("data-swup-transition");
                            // load page
                            this.loadPage({
                                url: link.getAddress(),
                                customTransition: customTransition
                            }, false);
                        }
                    }
                } else // open in new tab (do nothing)
                this.triggerEvent("openPageInNewTab", event);
            }
        },
        {
            key: "popStateHandler",
            value: function popStateHandler(event) {
                if (this.options.skipPopStateHandling(event)) return;
                var link = new $171c21fe9f651eea$exports.Link(event.state ? event.state.url : window.location.pathname);
                if (link.getHash() !== "") this.scrollToElement = link.getHash();
                else event.preventDefault();
                this.triggerEvent("popState", event);
                if (!this.options.animateHistoryBrowsing) {
                    document.documentElement.classList.remove("is-animating");
                    (0, $171c21fe9f651eea$exports.cleanupAnimationClasses)();
                }
                this.loadPage({
                    url: link.getAddress()
                }, event);
            }
        }
    ]);
    return Swup;
}();
$092b9decb7eceadc$exports.default = $092b9decb7eceadc$var$Swup;


var $f87ee47297a95c9c$exports = {};
(function webpackUniversalModuleDefinition(root, factory) {
    $f87ee47297a95c9c$exports = factory();
})(window, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 0);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _index = __webpack_require__(1);
            var _index2 = _interopRequireDefault(_index);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            module1.exports = _index2.default; // this is here for webpack to expose SwupTheme as window.SwupTheme
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _extends = Object.assign || function(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i];
                    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
                }
                return target;
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _theme = __webpack_require__(2);
            var _theme2 = _interopRequireDefault(_theme);
            var _index = __webpack_require__(3);
            var _index2 = _interopRequireDefault(_index);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var FadeTheme = function(_Theme) {
                _inherits(FadeTheme, _Theme);
                function FadeTheme(options) {
                    _classCallCheck(this, FadeTheme);
                    var _this = _possibleConstructorReturn(this, (FadeTheme.__proto__ || Object.getPrototypeOf(FadeTheme)).call(this));
                    _this.name = "FadeTheme";
                    var defaultOptions = {
                        mainElement: "#swup"
                    };
                    _this.options = _extends({}, defaultOptions, options);
                    return _this;
                }
                _createClass(FadeTheme, [
                    {
                        key: "mount",
                        value: function mount() {
                            this.applyStyles(_index2.default);
                            this.addClassName(this.options.mainElement, "main");
                        }
                    }
                ]);
                return FadeTheme;
            }(_theme2.default);
            exports.default = FadeTheme;
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var Theme = function() {
                function Theme() {
                    var _this = this;
                    _classCallCheck(this, Theme);
                    this._addedStyleElements = [];
                    this._addedHTMLContent = [];
                    this._classNameAddedToElements = [];
                    this._addClassNameToElement = function() {
                        _this._classNameAddedToElements.forEach(function(item) {
                            var elements = Array.prototype.slice.call(document.querySelectorAll(item.selector));
                            elements.forEach(function(element) {
                                element.classList.add("swup-transition-" + item.name);
                            });
                        });
                    };
                    this.isSwupPlugin = true;
                }
                _createClass(Theme, [
                    {
                        key: "_beforeMount",
                        value: function _beforeMount() {
                            // save original and replace animationSelector option
                            this._originalAnimationSelectorOption = String(this.swup.options.animationSelector);
                            this.swup.options.animationSelector = '[class*="swup-transition-"]';
                            // add classes after each content replace
                            this.swup.on("contentReplaced", this._addClassNameToElement);
                        }
                    },
                    {
                        key: "_afterUnmount",
                        value: function _afterUnmount() {
                            // reset animationSelector option
                            this.swup.options.animationSelector = this._originalAnimationSelectorOption;
                            // remove added styles
                            this._addedStyleElements.forEach(function(element) {
                                element.outerHTML = "";
                                element = null;
                            });
                            // remove added HTML
                            this._addedHTMLContent.forEach(function(element) {
                                element.outerHTML = "";
                                element = null;
                            });
                            // remove added classnames
                            this._classNameAddedToElements.forEach(function(item) {
                                var elements = Array.prototype.slice.call(document.querySelectorAll(item.selector));
                                elements.forEach(function(element) {
                                    element.className.split(" ").forEach(function(classItem) {
                                        if (new RegExp("^swup-transition-").test(classItem)) element.classList.remove(classItem);
                                    });
                                });
                            });
                            this.swup.off("contentReplaced", this._addClassNameToElement);
                        }
                    },
                    {
                        key: "mount",
                        value: function mount() {
                        // this is mount method rewritten by class extending
                        // and is executed when swup is enabled with theme
                        }
                    },
                    {
                        key: "unmount",
                        value: function unmount() {
                        // this is unmount method rewritten by class extending
                        // and is executed when swup with theme is disabled
                        }
                    },
                    {
                        key: "applyStyles",
                        value: function applyStyles(styles) {
                            var head = document.head;
                            var style = document.createElement("style");
                            style.setAttribute("data-swup-theme", "");
                            style.appendChild(document.createTextNode(styles));
                            this._addedStyleElements.push(style);
                            head.prepend(style);
                        }
                    },
                    {
                        key: "applyHTML",
                        value: function applyHTML(content) {
                            var element = document.createElement("div");
                            element.innerHTML = content;
                            this._addedHTMLContent.push(element);
                            document.body.appendChild(element);
                        }
                    },
                    {
                        key: "addClassName",
                        value: function addClassName(selector, name) {
                            // save so it can be later removed
                            this._classNameAddedToElements.push({
                                selector: selector,
                                name: name
                            });
                            // add class the first time
                            this._addClassNameToElement();
                        }
                    }
                ]);
                return Theme;
            }();
            exports.default = Theme;
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            exports = module1.exports = __webpack_require__(4)(false);
            // Module
            exports.push([
                module1.i,
                ".swup-transition-main {\n    opacity: 1;\n    transition: opacity .4s;\n}\n\nhtml.is-animating .swup-transition-main {\n    opacity: 0;\n}",
                ""
            ]);
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/ // css base code, injected by the css-loader
            module1.exports = function(useSourceMap) {
                var list = []; // return the list of modules as css string
                list.toString = function toString() {
                    return this.map(function(item) {
                        var content = cssWithMappingToString(item, useSourceMap);
                        if (item[2]) return "@media " + item[2] + "{" + content + "}";
                        else return content;
                    }).join("");
                }; // import a list of modules into the list
                list.i = function(modules, mediaQuery) {
                    if (typeof modules === "string") modules = [
                        [
                            null,
                            modules,
                            ""
                        ]
                    ];
                    var alreadyImportedModules = {};
                    for(var i = 0; i < this.length; i++){
                        var id = this[i][0];
                        if (id != null) alreadyImportedModules[id] = true;
                    }
                    for(i = 0; i < modules.length; i++){
                        var item = modules[i]; // skip already imported module
                        // this implementation is not 100% perfect for weird media query combinations
                        // when a module is imported multiple times with different media queries.
                        // I hope this will never occur (Hey this way we have smaller bundles)
                        if (item[0] == null || !alreadyImportedModules[item[0]]) {
                            if (mediaQuery && !item[2]) item[2] = mediaQuery;
                            else if (mediaQuery) item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
                            list.push(item);
                        }
                    }
                };
                return list;
            };
            function cssWithMappingToString(item, useSourceMap) {
                var content = item[1] || "";
                var cssMapping = item[3];
                if (!cssMapping) return content;
                if (useSourceMap && typeof btoa === "function") {
                    var sourceMapping = toComment(cssMapping);
                    var sourceURLs = cssMapping.sources.map(function(source) {
                        return "/*# sourceURL=" + cssMapping.sourceRoot + source + " */";
                    });
                    return [
                        content
                    ].concat(sourceURLs).concat([
                        sourceMapping
                    ]).join("\n");
                }
                return [
                    content
                ].join("\n");
            } // Adapted from convert-source-map (MIT)
            function toComment(sourceMap) {
                // eslint-disable-next-line no-undef
                var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
                var data = "sourceMappingURL=data:application/json;charset=utf-8;base64," + base64;
                return "/*# " + data + " */";
            }
        /***/ }
    ]);
});



function $aef471fcf281183e$var$FontsLoaded() {
    document.fonts.ready.then(()=>{
        document.querySelector("header[role=banner]").classList.add("font-loaded");
    });
}
function $aef471fcf281183e$var$removeControlsVideo() {
    const videos = document.querySelectorAll("video");
    if (videos.length > 0) for (const video of videos)video.removeAttribute("controls");
}
function $aef471fcf281183e$export$3e5bc5e5f78bf2fe() {
    const swup = new (0, (/*@__PURE__*/$parcel$interopDefault($092b9decb7eceadc$exports)))({
        linkSelector: `a[href^="/index"], a[href^="index"]`,
        plugins: [
            new (0, (/*@__PURE__*/$parcel$interopDefault($f87ee47297a95c9c$exports)))()
        ]
    });
    const initPage = ()=>{
        (0, $35da740d59af89ba$export$ca17b14bf34aba4)();
        $aef471fcf281183e$var$FontsLoaded();
        $aef471fcf281183e$var$removeControlsVideo();
    };
    initPage();
    swup.on("contentReplaced", ()=>{
        initPage();
    });
}


var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


var $48968958eb8b72e8$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $48968958eb8b72e8$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = "browser";
    }
    return BrowserInfo;
}();
var $48968958eb8b72e8$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = "node";
        this.name = "node";
        this.os = $cfae44f0dfdf62c0$exports.platform;
    }
    return NodeInfo;
}();
var $48968958eb8b72e8$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = "bot-device";
    }
    return SearchBotDeviceInfo;
}();
var $48968958eb8b72e8$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = "bot";
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $48968958eb8b72e8$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = "react-native";
        this.name = "react-native";
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $48968958eb8b72e8$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $48968958eb8b72e8$var$SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $48968958eb8b72e8$var$REQUIRED_VERSION_PARTS = 3;
var $48968958eb8b72e8$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "pie",
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        "pie",
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        "netfront",
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "curl",
        /^curl\/([0-9\.]+)$/
    ],
    [
        "searchbot",
        $48968958eb8b72e8$var$SEARCHBOX_UA_REGEX
    ]
];
var $48968958eb8b72e8$var$operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Windows CE",
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ]
];
function $48968958eb8b72e8$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $48968958eb8b72e8$export$1184956100eddc3c(userAgent);
    if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") return new $48968958eb8b72e8$export$7c78fe95a9d9b03e();
    if (typeof navigator !== "undefined") return $48968958eb8b72e8$export$1184956100eddc3c(navigator.userAgent);
    return $48968958eb8b72e8$export$bf2c6630ab904918();
}
function $48968958eb8b72e8$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== "" && $48968958eb8b72e8$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $48968958eb8b72e8$export$89ca9f8ca1a50fd5(ua) {
    var data = $48968958eb8b72e8$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $48968958eb8b72e8$export$1184956100eddc3c(ua) {
    var matchedRule = $48968958eb8b72e8$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new $48968958eb8b72e8$export$cb435e1e9f86c1ff();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split(".").join("_").split("_").slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $48968958eb8b72e8$var$REQUIRED_VERSION_PARTS) versionParts = $48968958eb8b72e8$var$__spreadArray($48968958eb8b72e8$var$__spreadArray([], versionParts, true), $48968958eb8b72e8$var$createVersionParts($48968958eb8b72e8$var$REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join(".");
    var os = $48968958eb8b72e8$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $48968958eb8b72e8$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $48968958eb8b72e8$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $48968958eb8b72e8$export$8fa985da04a86f0(name, version, os);
}
function $48968958eb8b72e8$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $48968958eb8b72e8$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $48968958eb8b72e8$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $48968958eb8b72e8$export$bf2c6630ab904918() {
    var isNode = typeof $cfae44f0dfdf62c0$exports !== "undefined" && $cfae44f0dfdf62c0$exports.version;
    return isNode ? new $48968958eb8b72e8$export$62457c674e0167c0($cfae44f0dfdf62c0$exports.version.slice(1)) : null;
}
function $48968958eb8b72e8$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}


var $c7997aef068a9f19$require$detect = $48968958eb8b72e8$export$17b446b869dad473;
const $c7997aef068a9f19$var$browser = $c7997aef068a9f19$require$detect();
const $c7997aef068a9f19$export$cfb3ac94d9068950 = $c7997aef068a9f19$var$browser.os === "Android OS" || $c7997aef068a9f19$var$browser.os === "iOS";
const $c7997aef068a9f19$export$95df08bae54cb4df = $c7997aef068a9f19$var$browser.name === "safari";
const $c7997aef068a9f19$export$990c0428cbb6d662 = ()=>{
    const pathNameMatch = window.location.pathname.match(/\d/);
    return pathNameMatch !== null ? Number(pathNameMatch[0]) : 1;
};
const $c7997aef068a9f19$var$vhDevices = ()=>{
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
};
function $c7997aef068a9f19$export$eab97d15b1788b8d() {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve();
            $c7997aef068a9f19$var$vhDevices();
            window.addEventListener("resize", ()=>{
                $c7997aef068a9f19$var$vhDevices();
            });
        }, 10);
    });
}



function $3acd474ceacf8a38$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}



var $7c4cf709d1826294$var$noop = {
    value: ()=>{}
};
function $7c4cf709d1826294$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $7c4cf709d1826294$var$Dispatch(_);
}
function $7c4cf709d1826294$var$Dispatch(_) {
    this._ = _;
}
function $7c4cf709d1826294$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$7c4cf709d1826294$var$Dispatch.prototype = $7c4cf709d1826294$var$dispatch.prototype = {
    constructor: $7c4cf709d1826294$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $7c4cf709d1826294$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $7c4cf709d1826294$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $7c4cf709d1826294$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $7c4cf709d1826294$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $7c4cf709d1826294$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $7c4cf709d1826294$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $7c4cf709d1826294$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $7c4cf709d1826294$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $7c4cf709d1826294$export$2e2bcd8739ae039 = $7c4cf709d1826294$var$dispatch;



function $6e0da2549057218e$var$none() {}
function $6e0da2549057218e$export$2e2bcd8739ae039(selector) {
    return selector == null ? $6e0da2549057218e$var$none : function() {
        return this.querySelector(selector);
    };
}


function $31121acbef1e6956$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $6e0da2549057218e$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(subgroups, this._parents);
}



// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
function $cade2308c136039a$export$2e2bcd8739ae039(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}


function $7d92e4f75dbef49d$var$empty() {
    return [];
}
function $7d92e4f75dbef49d$export$2e2bcd8739ae039(selector) {
    return selector == null ? $7d92e4f75dbef49d$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $a3d7edd03ec30cc1$var$arrayAll(select) {
    return function() {
        return (0, $cade2308c136039a$export$2e2bcd8739ae039)(select.apply(this, arguments));
    };
}
function $a3d7edd03ec30cc1$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $a3d7edd03ec30cc1$var$arrayAll(select);
    else select = (0, $7d92e4f75dbef49d$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(subgroups, parents);
}


function $5fb24786d2a5f87a$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $5fb24786d2a5f87a$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}


var $31ffd623f27a3a65$var$find = Array.prototype.find;
function $31ffd623f27a3a65$var$childFind(match) {
    return function() {
        return $31ffd623f27a3a65$var$find.call(this.children, match);
    };
}
function $31ffd623f27a3a65$var$childFirst() {
    return this.firstElementChild;
}
function $31ffd623f27a3a65$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $31ffd623f27a3a65$var$childFirst : $31ffd623f27a3a65$var$childFind(typeof match === "function" ? match : (0, $5fb24786d2a5f87a$export$90c2759c036528)(match)));
}



var $956143cec557381d$var$filter = Array.prototype.filter;
function $956143cec557381d$var$children() {
    return Array.from(this.children);
}
function $956143cec557381d$var$childrenFilter(match) {
    return function() {
        return $956143cec557381d$var$filter.call(this.children, match);
    };
}
function $956143cec557381d$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $956143cec557381d$var$children : $956143cec557381d$var$childrenFilter(typeof match === "function" ? match : (0, $5fb24786d2a5f87a$export$90c2759c036528)(match)));
}




function $ebbd333b038c2847$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $5fb24786d2a5f87a$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(subgroups, this._parents);
}



function $e7fb628d3a97a780$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $3e99928b06782938$export$2e2bcd8739ae039() {
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(this._enter || this._groups.map((0, $e7fb628d3a97a780$export$2e2bcd8739ae039)), this._parents);
}
function $3e99928b06782938$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$3e99928b06782938$export$67b01759a14cf6a4.prototype = {
    constructor: $3e99928b06782938$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};


function $d8d677a8510c2e55$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $cf943aeeeea8dffb$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $3e99928b06782938$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $cf943aeeeea8dffb$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $3e99928b06782938$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $cf943aeeeea8dffb$var$datum(node) {
    return node.__data__;
}
function $cf943aeeeea8dffb$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $cf943aeeeea8dffb$var$datum);
    var bind = key ? $cf943aeeeea8dffb$var$bindKey : $cf943aeeeea8dffb$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $d8d677a8510c2e55$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = $cf943aeeeea8dffb$var$arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function $cf943aeeeea8dffb$var$arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}





function $69a673ff94b874e4$export$2e2bcd8739ae039() {
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(this._exit || this._groups.map((0, $e7fb628d3a97a780$export$2e2bcd8739ae039)), this._parents);
}


function $80f6488751784891$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    if (typeof onenter === "function") {
        enter = onenter(enter);
        if (enter) enter = enter.selection();
    } else enter = enter.append(onenter + "");
    if (onupdate != null) {
        update = onupdate(update);
        if (update) update = update.selection();
    }
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}



function $63bab9b342eb32db$export$2e2bcd8739ae039(context) {
    var selection = context.selection ? context.selection() : context;
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(merges, this._parents);
}


function $7a935994b7a1f6cf$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $faed8eab1469f61d$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $faed8eab1469f61d$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $faed8eab1469f61d$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $fa7212ea177e0f60$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $c2d66609f799a53b$export$2e2bcd8739ae039() {
    return Array.from(this);
}


function $cb2fe8996a284614$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $8d2a1d37edc5fc51$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}


function $3ed6ae19ad0a17a6$export$2e2bcd8739ae039() {
    return !this.node();
}


function $4a407aa055eb21e9$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}


var $53f2bc3e7847f93d$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $53f2bc3e7847f93d$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $53f2bc3e7847f93d$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $b659c67af9335162$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $53f2bc3e7847f93d$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $53f2bc3e7847f93d$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}


function $8ba31651ad7591ba$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $8ba31651ad7591ba$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $8ba31651ad7591ba$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $8ba31651ad7591ba$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $8ba31651ad7591ba$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $8ba31651ad7591ba$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $8ba31651ad7591ba$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $8ba31651ad7591ba$var$attrRemoveNS : $8ba31651ad7591ba$var$attrRemove : typeof value === "function" ? fullname.local ? $8ba31651ad7591ba$var$attrFunctionNS : $8ba31651ad7591ba$var$attrFunction : fullname.local ? $8ba31651ad7591ba$var$attrConstantNS : $8ba31651ad7591ba$var$attrConstant)(fullname, value));
}


function $89f2562a5a0d5a13$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $6abb942964e997ae$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $6abb942964e997ae$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $6abb942964e997ae$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $6abb942964e997ae$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $6abb942964e997ae$var$styleRemove : typeof value === "function" ? $6abb942964e997ae$var$styleFunction : $6abb942964e997ae$var$styleConstant)(name, value, priority == null ? "" : priority)) : $6abb942964e997ae$export$5e3cec964f0b5efd(this.node(), name);
}
function $6abb942964e997ae$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $89f2562a5a0d5a13$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $2b37810bbc11c28b$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $2b37810bbc11c28b$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $2b37810bbc11c28b$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $2b37810bbc11c28b$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $2b37810bbc11c28b$var$propertyRemove : typeof value === "function" ? $2b37810bbc11c28b$var$propertyFunction : $2b37810bbc11c28b$var$propertyConstant)(name, value)) : this.node()[name];
}


function $6515c3ccac9efd7a$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $6515c3ccac9efd7a$var$classList(node) {
    return node.classList || new $6515c3ccac9efd7a$var$ClassList(node);
}
function $6515c3ccac9efd7a$var$ClassList(node) {
    this._node = node;
    this._names = $6515c3ccac9efd7a$var$classArray(node.getAttribute("class") || "");
}
$6515c3ccac9efd7a$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $6515c3ccac9efd7a$var$classedAdd(node, names) {
    var list = $6515c3ccac9efd7a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $6515c3ccac9efd7a$var$classedRemove(node, names) {
    var list = $6515c3ccac9efd7a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $6515c3ccac9efd7a$var$classedTrue(names) {
    return function() {
        $6515c3ccac9efd7a$var$classedAdd(this, names);
    };
}
function $6515c3ccac9efd7a$var$classedFalse(names) {
    return function() {
        $6515c3ccac9efd7a$var$classedRemove(this, names);
    };
}
function $6515c3ccac9efd7a$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $6515c3ccac9efd7a$var$classedAdd : $6515c3ccac9efd7a$var$classedRemove)(this, names);
    };
}
function $6515c3ccac9efd7a$export$2e2bcd8739ae039(name, value) {
    var names = $6515c3ccac9efd7a$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $6515c3ccac9efd7a$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $6515c3ccac9efd7a$var$classedFunction : value ? $6515c3ccac9efd7a$var$classedTrue : $6515c3ccac9efd7a$var$classedFalse)(names, value));
}


function $23bcbc7d81179ba9$var$textRemove() {
    this.textContent = "";
}
function $23bcbc7d81179ba9$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $23bcbc7d81179ba9$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $23bcbc7d81179ba9$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $23bcbc7d81179ba9$var$textRemove : (typeof value === "function" ? $23bcbc7d81179ba9$var$textFunction : $23bcbc7d81179ba9$var$textConstant)(value)) : this.node().textContent;
}


function $d5514f1406649954$var$htmlRemove() {
    this.innerHTML = "";
}
function $d5514f1406649954$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $d5514f1406649954$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $d5514f1406649954$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $d5514f1406649954$var$htmlRemove : (typeof value === "function" ? $d5514f1406649954$var$htmlFunction : $d5514f1406649954$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $c6aae8ef09c3d03d$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $c6aae8ef09c3d03d$export$2e2bcd8739ae039() {
    return this.each($c6aae8ef09c3d03d$var$raise);
}


function $4669a19c71181bd1$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $4669a19c71181bd1$export$2e2bcd8739ae039() {
    return this.each($4669a19c71181bd1$var$lower);
}




function $8408c2f95f59818f$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $53f2bc3e7847f93d$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $53f2bc3e7847f93d$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $8408c2f95f59818f$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $8408c2f95f59818f$export$2e2bcd8739ae039(name) {
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $8408c2f95f59818f$var$creatorFixed : $8408c2f95f59818f$var$creatorInherit)(fullname);
}


function $00a766249763e814$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $8408c2f95f59818f$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $45485f4f27d149f8$var$constantNull() {
    return null;
}
function $45485f4f27d149f8$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $8408c2f95f59818f$export$2e2bcd8739ae039)(name), select = before == null ? $45485f4f27d149f8$var$constantNull : typeof before === "function" ? before : (0, $6e0da2549057218e$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $d587d6535138580c$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $d587d6535138580c$export$2e2bcd8739ae039() {
    return this.each($d587d6535138580c$var$remove);
}


function $3323c835dc2d74de$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $3323c835dc2d74de$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $3323c835dc2d74de$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $3323c835dc2d74de$var$selection_cloneDeep : $3323c835dc2d74de$var$selection_cloneShallow);
}


function $d048e3258aa4fe8e$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


function $dd1fb49221ad966f$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $dd1fb49221ad966f$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $dd1fb49221ad966f$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $dd1fb49221ad966f$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $dd1fb49221ad966f$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $dd1fb49221ad966f$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $dd1fb49221ad966f$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $dd1fb49221ad966f$var$onAdd : $dd1fb49221ad966f$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}



function $27c639e461d8a390$var$dispatchEvent(node, type, params) {
    var window = (0, $89f2562a5a0d5a13$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $27c639e461d8a390$var$dispatchConstant(type, params) {
    return function() {
        return $27c639e461d8a390$var$dispatchEvent(this, type, params);
    };
}
function $27c639e461d8a390$var$dispatchFunction(type, params) {
    return function() {
        return $27c639e461d8a390$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $27c639e461d8a390$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $27c639e461d8a390$var$dispatchFunction : $27c639e461d8a390$var$dispatchConstant)(type, params));
}


function* $98373fa9c0ecbfb2$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}


var $28a9f77d63e1ff25$export$e8e78c978b129247 = [
    null
];
function $28a9f77d63e1ff25$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $28a9f77d63e1ff25$var$selection() {
    return new $28a9f77d63e1ff25$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $28a9f77d63e1ff25$export$e8e78c978b129247);
}
function $28a9f77d63e1ff25$var$selection_selection() {
    return this;
}
$28a9f77d63e1ff25$export$52baac22726c72bf.prototype = $28a9f77d63e1ff25$var$selection.prototype = {
    constructor: $28a9f77d63e1ff25$export$52baac22726c72bf,
    select: (0, $31121acbef1e6956$export$2e2bcd8739ae039),
    selectAll: (0, $a3d7edd03ec30cc1$export$2e2bcd8739ae039),
    selectChild: (0, $31ffd623f27a3a65$export$2e2bcd8739ae039),
    selectChildren: (0, $956143cec557381d$export$2e2bcd8739ae039),
    filter: (0, $ebbd333b038c2847$export$2e2bcd8739ae039),
    data: (0, $cf943aeeeea8dffb$export$2e2bcd8739ae039),
    enter: (0, $3e99928b06782938$export$2e2bcd8739ae039),
    exit: (0, $69a673ff94b874e4$export$2e2bcd8739ae039),
    join: (0, $80f6488751784891$export$2e2bcd8739ae039),
    merge: (0, $63bab9b342eb32db$export$2e2bcd8739ae039),
    selection: $28a9f77d63e1ff25$var$selection_selection,
    order: (0, $7a935994b7a1f6cf$export$2e2bcd8739ae039),
    sort: (0, $faed8eab1469f61d$export$2e2bcd8739ae039),
    call: (0, $fa7212ea177e0f60$export$2e2bcd8739ae039),
    nodes: (0, $c2d66609f799a53b$export$2e2bcd8739ae039),
    node: (0, $cb2fe8996a284614$export$2e2bcd8739ae039),
    size: (0, $8d2a1d37edc5fc51$export$2e2bcd8739ae039),
    empty: (0, $3ed6ae19ad0a17a6$export$2e2bcd8739ae039),
    each: (0, $4a407aa055eb21e9$export$2e2bcd8739ae039),
    attr: (0, $8ba31651ad7591ba$export$2e2bcd8739ae039),
    style: (0, $6abb942964e997ae$export$2e2bcd8739ae039),
    property: (0, $2b37810bbc11c28b$export$2e2bcd8739ae039),
    classed: (0, $6515c3ccac9efd7a$export$2e2bcd8739ae039),
    text: (0, $23bcbc7d81179ba9$export$2e2bcd8739ae039),
    html: (0, $d5514f1406649954$export$2e2bcd8739ae039),
    raise: (0, $c6aae8ef09c3d03d$export$2e2bcd8739ae039),
    lower: (0, $4669a19c71181bd1$export$2e2bcd8739ae039),
    append: (0, $00a766249763e814$export$2e2bcd8739ae039),
    insert: (0, $45485f4f27d149f8$export$2e2bcd8739ae039),
    remove: (0, $d587d6535138580c$export$2e2bcd8739ae039),
    clone: (0, $3323c835dc2d74de$export$2e2bcd8739ae039),
    datum: (0, $d048e3258aa4fe8e$export$2e2bcd8739ae039),
    on: (0, $dd1fb49221ad966f$export$2e2bcd8739ae039),
    dispatch: (0, $27c639e461d8a390$export$2e2bcd8739ae039),
    [Symbol.iterator]: (0, $98373fa9c0ecbfb2$export$2e2bcd8739ae039)
};
var $28a9f77d63e1ff25$export$2e2bcd8739ae039 = $28a9f77d63e1ff25$var$selection;


function $cf81072cf307ee25$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)([
        [
            selector
        ]
    ], (0, $28a9f77d63e1ff25$export$e8e78c978b129247));
}


// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
const $914edae09cbfb4c0$export$524615cd03e458cc = {
    passive: false
};
const $914edae09cbfb4c0$export$35431a0e47022de1 = {
    capture: true,
    passive: false
};
function $914edae09cbfb4c0$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $914edae09cbfb4c0$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


function $905558291b0c219c$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(view).on("dragstart.drag", (0, $914edae09cbfb4c0$export$2e2bcd8739ae039), (0, $914edae09cbfb4c0$export$35431a0e47022de1));
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $914edae09cbfb4c0$export$2e2bcd8739ae039), (0, $914edae09cbfb4c0$export$35431a0e47022de1));
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $905558291b0c219c$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $914edae09cbfb4c0$export$2e2bcd8739ae039), (0, $914edae09cbfb4c0$export$35431a0e47022de1));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}



var $bYoiY = parcelRequire("bYoiY");

var $bYoiY = parcelRequire("bYoiY");
function $dd5733431a2d0880$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $dd5733431a2d0880$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $dd5733431a2d0880$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $68731c1c421d9916$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $dd5733431a2d0880$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $78a660cd70c52f6f$export$2e2bcd8739ae039 = (x)=>()=>x;


function $529dc8928f6a4077$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $529dc8928f6a4077$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $529dc8928f6a4077$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $529dc8928f6a4077$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $529dc8928f6a4077$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $529dc8928f6a4077$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $529dc8928f6a4077$var$exponential(a, b, y) : (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $529dc8928f6a4077$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $529dc8928f6a4077$var$linear(a, d) : (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $e7e88f7f6ed95eef$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $529dc8928f6a4077$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $bYoiY.rgb)(start)).r, (end = (0, $bYoiY.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $e7e88f7f6ed95eef$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $bYoiY.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $e7e88f7f6ed95eef$export$2c0e28f2e2852d3f = $e7e88f7f6ed95eef$var$rgbSpline((0, $dd5733431a2d0880$export$2e2bcd8739ae039));
var $e7e88f7f6ed95eef$export$53d5214f625ccd4c = $e7e88f7f6ed95eef$var$rgbSpline((0, $68731c1c421d9916$export$2e2bcd8739ae039));



function $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $23bbf03008765dcc$export$2e2bcd8739ae039(a, b) {
    return ((0, $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8)(b) ? (0, $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039) : $23bbf03008765dcc$export$15d09067c6a5ee49)(a, b);
}
function $23bbf03008765dcc$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $8385105b4986daed$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $063cbb46f86ba478$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $bebed377ddb9d3af$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $cf536f4647e343d9$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $8385105b4986daed$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $020916edd93bff72$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $020916edd93bff72$var$reB = new RegExp($020916edd93bff72$var$reA.source, "g");
function $020916edd93bff72$var$zero(b) {
    return function() {
        return b;
    };
}
function $020916edd93bff72$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $020916edd93bff72$export$2e2bcd8739ae039(a, b) {
    var bi = $020916edd93bff72$var$reA.lastIndex = $020916edd93bff72$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $020916edd93bff72$var$reA.exec(a)) && (bm = $020916edd93bff72$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $020916edd93bff72$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $020916edd93bff72$var$one(q[0].x) : $020916edd93bff72$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $8385105b4986daed$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $bebed377ddb9d3af$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $bYoiY.default)(b)) ? (b = c, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (0, $020916edd93bff72$export$2e2bcd8739ae039) : b instanceof (0, $bYoiY.default) ? (0, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : b instanceof Date ? (0, $063cbb46f86ba478$export$2e2bcd8739ae039) : (0, $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8)(b) ? (0, $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $23bbf03008765dcc$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $cf536f4647e343d9$export$2e2bcd8739ae039) : (0, $bebed377ddb9d3af$export$2e2bcd8739ae039))(a, b);
}


function $c447ae86a8320d39$export$2e2bcd8739ae039(event) {
    let sourceEvent;
    while(sourceEvent = event.sourceEvent)event = sourceEvent;
    return event;
}


function $1be794af963d8372$export$2e2bcd8739ae039(event, node) {
    event = (0, $c447ae86a8320d39$export$2e2bcd8739ae039)(event);
    if (node === undefined) node = event.currentTarget;
    if (node) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        if (node.getBoundingClientRect) {
            var rect = node.getBoundingClientRect();
            return [
                event.clientX - rect.left - node.clientLeft,
                event.clientY - rect.top - node.clientTop
            ];
        }
    }
    return [
        event.pageX,
        event.pageY
    ];
}




var $e782289d8bd71451$var$frame = 0, $e782289d8bd71451$var$timeout = 0, $e782289d8bd71451$var$interval = 0, $e782289d8bd71451$var$pokeDelay = 1000, $e782289d8bd71451$var$taskHead, $e782289d8bd71451$var$taskTail, $e782289d8bd71451$var$clockLast = 0, $e782289d8bd71451$var$clockNow = 0, $e782289d8bd71451$var$clockSkew = 0, $e782289d8bd71451$var$clock = typeof performance === "object" && performance.now ? performance : Date, $e782289d8bd71451$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $e782289d8bd71451$export$461939dd4422153() {
    return $e782289d8bd71451$var$clockNow || ($e782289d8bd71451$var$setFrame($e782289d8bd71451$var$clearNow), $e782289d8bd71451$var$clockNow = $e782289d8bd71451$var$clock.now() + $e782289d8bd71451$var$clockSkew);
}
function $e782289d8bd71451$var$clearNow() {
    $e782289d8bd71451$var$clockNow = 0;
}
function $e782289d8bd71451$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$e782289d8bd71451$export$c57e9b2d8b9e4de.prototype = $e782289d8bd71451$export$9dc4ecf953986f04.prototype = {
    constructor: $e782289d8bd71451$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $e782289d8bd71451$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $e782289d8bd71451$var$taskTail !== this) {
            if ($e782289d8bd71451$var$taskTail) $e782289d8bd71451$var$taskTail._next = this;
            else $e782289d8bd71451$var$taskHead = this;
            $e782289d8bd71451$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $e782289d8bd71451$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $e782289d8bd71451$var$sleep();
        }
    }
};
function $e782289d8bd71451$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $e782289d8bd71451$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $e782289d8bd71451$export$d60154c1d7f3990e() {
    $e782289d8bd71451$export$461939dd4422153(); // Get the current time, if not already set.
    ++$e782289d8bd71451$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $e782289d8bd71451$var$taskHead, e;
    while(t){
        if ((e = $e782289d8bd71451$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$e782289d8bd71451$var$frame;
}
function $e782289d8bd71451$var$wake() {
    $e782289d8bd71451$var$clockNow = ($e782289d8bd71451$var$clockLast = $e782289d8bd71451$var$clock.now()) + $e782289d8bd71451$var$clockSkew;
    $e782289d8bd71451$var$frame = $e782289d8bd71451$var$timeout = 0;
    try {
        $e782289d8bd71451$export$d60154c1d7f3990e();
    } finally{
        $e782289d8bd71451$var$frame = 0;
        $e782289d8bd71451$var$nap();
        $e782289d8bd71451$var$clockNow = 0;
    }
}
function $e782289d8bd71451$var$poke() {
    var now = $e782289d8bd71451$var$clock.now(), delay = now - $e782289d8bd71451$var$clockLast;
    if (delay > $e782289d8bd71451$var$pokeDelay) $e782289d8bd71451$var$clockSkew -= delay, $e782289d8bd71451$var$clockLast = now;
}
function $e782289d8bd71451$var$nap() {
    var t0, t1 = $e782289d8bd71451$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $e782289d8bd71451$var$taskHead = t2;
    }
    $e782289d8bd71451$var$taskTail = t0;
    $e782289d8bd71451$var$sleep(time);
}
function $e782289d8bd71451$var$sleep(time) {
    if ($e782289d8bd71451$var$frame) return; // Soonest alarm already set, or will be.
    if ($e782289d8bd71451$var$timeout) $e782289d8bd71451$var$timeout = clearTimeout($e782289d8bd71451$var$timeout);
    var delay = time - $e782289d8bd71451$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $e782289d8bd71451$var$timeout = setTimeout($e782289d8bd71451$var$wake, time - $e782289d8bd71451$var$clock.now() - $e782289d8bd71451$var$clockSkew);
        if ($e782289d8bd71451$var$interval) $e782289d8bd71451$var$interval = clearInterval($e782289d8bd71451$var$interval);
    } else {
        if (!$e782289d8bd71451$var$interval) $e782289d8bd71451$var$clockLast = $e782289d8bd71451$var$clock.now(), $e782289d8bd71451$var$interval = setInterval($e782289d8bd71451$var$poke, $e782289d8bd71451$var$pokeDelay);
        $e782289d8bd71451$var$frame = 1, $e782289d8bd71451$var$setFrame($e782289d8bd71451$var$wake);
    }
}


function $d15c972f8843a0f2$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $e782289d8bd71451$export$c57e9b2d8b9e4de);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}


var $150ba4634a330696$var$emptyOn = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("start", "end", "cancel", "interrupt");
var $150ba4634a330696$var$emptyTween = [];
var $150ba4634a330696$export$ff39ebd4bb12b718 = 0;
var $150ba4634a330696$export$584530fe98d14a84 = 1;
var $150ba4634a330696$export$a5d151aee16efd42 = 2;
var $150ba4634a330696$export$fb935ab5849a0db9 = 3;
var $150ba4634a330696$export$1573e22b087389af = 4;
var $150ba4634a330696$export$a2e792214ded83b2 = 5;
var $150ba4634a330696$export$9d38167254403955 = 6;
function $150ba4634a330696$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $150ba4634a330696$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $150ba4634a330696$var$emptyOn,
        tween: $150ba4634a330696$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $150ba4634a330696$export$ff39ebd4bb12b718
    });
}
function $150ba4634a330696$export$2cd8252107eb640b(node, id) {
    var schedule = $150ba4634a330696$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $150ba4634a330696$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $150ba4634a330696$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $150ba4634a330696$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $150ba4634a330696$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $150ba4634a330696$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $150ba4634a330696$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $e782289d8bd71451$export$9dc4ecf953986f04)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $150ba4634a330696$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $150ba4634a330696$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $150ba4634a330696$export$fb935ab5849a0db9) return (0, $d15c972f8843a0f2$export$2e2bcd8739ae039)(start);
            // Interrupt the active transition, if any.
            if (o.state === $150ba4634a330696$export$1573e22b087389af) {
                o.state = $150ba4634a330696$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $150ba4634a330696$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $d15c972f8843a0f2$export$2e2bcd8739ae039)(function() {
            if (self.state === $150ba4634a330696$export$fb935ab5849a0db9) {
                self.state = $150ba4634a330696$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $150ba4634a330696$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $150ba4634a330696$export$a5d151aee16efd42) return; // interrupted
        self.state = $150ba4634a330696$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $150ba4634a330696$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $150ba4634a330696$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $150ba4634a330696$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}


function $b05ce272ee11a654$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $150ba4634a330696$export$a5d151aee16efd42) && schedule.state < (0, $150ba4634a330696$export$a2e792214ded83b2);
        schedule.state = (0, $150ba4634a330696$export$9d38167254403955);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}


function $c1dd383074e2630e$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this, name);
    });
}




var $2938f7d64470581a$var$degrees = 180 / Math.PI;
var $2938f7d64470581a$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $2938f7d64470581a$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $2938f7d64470581a$var$degrees,
        skewX: Math.atan(skewX) * $2938f7d64470581a$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


var $4a001faa54972590$var$svgNode;
function $4a001faa54972590$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $2938f7d64470581a$export$f0954fd7d5368655) : (0, $2938f7d64470581a$export$2e2bcd8739ae039)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $4a001faa54972590$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $2938f7d64470581a$export$f0954fd7d5368655;
    if (!$4a001faa54972590$var$svgNode) $4a001faa54972590$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $4a001faa54972590$var$svgNode.setAttribute("transform", value);
    if (!(value = $4a001faa54972590$var$svgNode.transform.baseVal.consolidate())) return 0, $2938f7d64470581a$export$f0954fd7d5368655;
    value = value.matrix;
    return (0, $2938f7d64470581a$export$2e2bcd8739ae039)(value.a, value.b, value.c, value.d, value.e, value.f);
}


function $e4d1a233c7242264$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $e4d1a233c7242264$export$56bec7123bb3589a = $e4d1a233c7242264$var$interpolateTransform((0, $4a001faa54972590$export$59ad369bf4938177), "px, ", "px)", "deg)");
var $e4d1a233c7242264$export$da8cba906d64c082 = $e4d1a233c7242264$var$interpolateTransform((0, $4a001faa54972590$export$f9ef43f9a1d89a18), ", ", ")", ")");




function $922feb1dfe9c8dcf$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $922feb1dfe9c8dcf$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $922feb1dfe9c8dcf$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $922feb1dfe9c8dcf$var$tweenRemove : $922feb1dfe9c8dcf$var$tweenFunction)(id, name, value));
}
function $922feb1dfe9c8dcf$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id).value[name];
    };
}



var $bYoiY = parcelRequire("bYoiY");

function $8a713565676b726d$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $bebed377ddb9d3af$export$2e2bcd8739ae039) : b instanceof (0, $bYoiY.default) ? (0, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (c = (0, $bYoiY.default)(b)) ? (b = c, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (0, $020916edd93bff72$export$2e2bcd8739ae039))(a, b);
}


function $2a651cfc4e49b53d$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $2a651cfc4e49b53d$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $2a651cfc4e49b53d$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $2a651cfc4e49b53d$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $2a651cfc4e49b53d$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $2a651cfc4e49b53d$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $2a651cfc4e49b53d$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name), i = fullname === "transform" ? (0, $e4d1a233c7242264$export$da8cba906d64c082) : (0, $8a713565676b726d$export$2e2bcd8739ae039);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $2a651cfc4e49b53d$var$attrFunctionNS : $2a651cfc4e49b53d$var$attrFunction)(fullname, i, (0, $922feb1dfe9c8dcf$export$f78ce6ab10405d82)(this, "attr." + name, value)) : value == null ? (fullname.local ? $2a651cfc4e49b53d$var$attrRemoveNS : $2a651cfc4e49b53d$var$attrRemove)(fullname) : (fullname.local ? $2a651cfc4e49b53d$var$attrConstantNS : $2a651cfc4e49b53d$var$attrConstant)(fullname, i, value));
}



function $cad13035adb29669$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $cad13035adb29669$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $cad13035adb29669$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $cad13035adb29669$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $cad13035adb29669$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $cad13035adb29669$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $cad13035adb29669$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name);
    return this.tween(key, (fullname.local ? $cad13035adb29669$var$attrTweenNS : $cad13035adb29669$var$attrTween)(fullname, value));
}



function $09cd57996bd81614$var$delayFunction(id, value) {
    return function() {
        (0, $150ba4634a330696$export$2cd8252107eb640b)(this, id).delay = +value.apply(this, arguments);
    };
}
function $09cd57996bd81614$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $150ba4634a330696$export$2cd8252107eb640b)(this, id).delay = value;
    };
}
function $09cd57996bd81614$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $09cd57996bd81614$var$delayFunction : $09cd57996bd81614$var$delayConstant)(id, value)) : (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).delay;
}



function $9c9f124117d5bf14$var$durationFunction(id, value) {
    return function() {
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).duration = +value.apply(this, arguments);
    };
}
function $9c9f124117d5bf14$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).duration = value;
    };
}
function $9c9f124117d5bf14$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $9c9f124117d5bf14$var$durationFunction : $9c9f124117d5bf14$var$durationConstant)(id, value)) : (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).duration;
}



function $8ea7852b6976e6d1$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).ease = value;
    };
}
function $8ea7852b6976e6d1$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($8ea7852b6976e6d1$var$easeConstant(id, value)) : (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).ease;
}



function $9d186bb80d60f6c9$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).ease = v;
    };
}
function $9d186bb80d60f6c9$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($9d186bb80d60f6c9$var$easeVarying(this._id, value));
}




function $c1e3543439d9f5fd$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $5fb24786d2a5f87a$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(subgroups, this._parents, this._name, this._id);
}



function $e7e726720f484153$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(merges, this._parents, this._name, this._id);
}



function $fd664209e896113c$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $fd664209e896113c$var$onFunction(id, name, listener) {
    var on0, on1, sit = $fd664209e896113c$var$start(name) ? (0, $150ba4634a330696$export$2cd8252107eb640b) : (0, $150ba4634a330696$export$adaa4cf7ef1b65be);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $fd664209e896113c$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).on.on(name) : this.each($fd664209e896113c$var$onFunction(id, name, listener));
}


function $b59e1b517983ad92$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $b59e1b517983ad92$export$2e2bcd8739ae039() {
    return this.on("end.remove", $b59e1b517983ad92$var$removeFunction(this._id));
}





function $9c22ba9ec568d18f$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $6e0da2549057218e$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $150ba4634a330696$export$2e2bcd8739ae039)(subgroup[i], name, id, i, subgroup, (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id));
        }
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(subgroups, this._parents, name, id);
}





function $79e977f9a26c99f1$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $7d92e4f75dbef49d$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $150ba4634a330696$export$2e2bcd8739ae039)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(subgroups, parents, name, id);
}



var $13be595fcf5febb7$var$Selection = (0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype.constructor;
function $13be595fcf5febb7$export$2e2bcd8739ae039() {
    return new $13be595fcf5febb7$var$Selection(this._groups, this._parents);
}







function $d0bf366fdef4c332$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name), string1 = (this.style.removeProperty(name), (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $d0bf366fdef4c332$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $d0bf366fdef4c332$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $d0bf366fdef4c332$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $d0bf366fdef4c332$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $d0bf366fdef4c332$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $d0bf366fdef4c332$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $e4d1a233c7242264$export$56bec7123bb3589a) : (0, $8a713565676b726d$export$2e2bcd8739ae039);
    return value == null ? this.styleTween(name, $d0bf366fdef4c332$var$styleNull(name, i)).on("end.style." + name, $d0bf366fdef4c332$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $d0bf366fdef4c332$var$styleFunction(name, i, (0, $922feb1dfe9c8dcf$export$f78ce6ab10405d82)(this, "style." + name, value))).each($d0bf366fdef4c332$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $d0bf366fdef4c332$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}


function $83672080502c9717$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $83672080502c9717$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $83672080502c9717$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $83672080502c9717$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $83672080502c9717$var$styleTween(name, value, priority == null ? "" : priority));
}



function $e62b6dd5e7df40e7$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $e62b6dd5e7df40e7$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $e62b6dd5e7df40e7$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $e62b6dd5e7df40e7$var$textFunction((0, $922feb1dfe9c8dcf$export$f78ce6ab10405d82)(this, "text", value)) : $e62b6dd5e7df40e7$var$textConstant(value == null ? "" : value + ""));
}


function $64d823b28aa7019a$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $64d823b28aa7019a$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $64d823b28aa7019a$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $64d823b28aa7019a$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $64d823b28aa7019a$var$textTween(value));
}




function $e8ee9e113d6ecbba$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id0);
            (0, $150ba4634a330696$export$2e2bcd8739ae039)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(groups, this._parents, name, id1);
}




function $5220ae42feb560ba$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}


var $a4d5b9ef4f9cfabb$var$id = 0;
function $a4d5b9ef4f9cfabb$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $a4d5b9ef4f9cfabb$export$2e2bcd8739ae039(name) {
    return (0, $28a9f77d63e1ff25$export$2e2bcd8739ae039)().transition(name);
}
function $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b() {
    return ++$a4d5b9ef4f9cfabb$var$id;
}
var $a4d5b9ef4f9cfabb$var$selection_prototype = (0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype;
$a4d5b9ef4f9cfabb$export$be58926105124dd4.prototype = $a4d5b9ef4f9cfabb$export$2e2bcd8739ae039.prototype = {
    constructor: $a4d5b9ef4f9cfabb$export$be58926105124dd4,
    select: (0, $9c22ba9ec568d18f$export$2e2bcd8739ae039),
    selectAll: (0, $79e977f9a26c99f1$export$2e2bcd8739ae039),
    selectChild: $a4d5b9ef4f9cfabb$var$selection_prototype.selectChild,
    selectChildren: $a4d5b9ef4f9cfabb$var$selection_prototype.selectChildren,
    filter: (0, $c1e3543439d9f5fd$export$2e2bcd8739ae039),
    merge: (0, $e7e726720f484153$export$2e2bcd8739ae039),
    selection: (0, $13be595fcf5febb7$export$2e2bcd8739ae039),
    transition: (0, $e8ee9e113d6ecbba$export$2e2bcd8739ae039),
    call: $a4d5b9ef4f9cfabb$var$selection_prototype.call,
    nodes: $a4d5b9ef4f9cfabb$var$selection_prototype.nodes,
    node: $a4d5b9ef4f9cfabb$var$selection_prototype.node,
    size: $a4d5b9ef4f9cfabb$var$selection_prototype.size,
    empty: $a4d5b9ef4f9cfabb$var$selection_prototype.empty,
    each: $a4d5b9ef4f9cfabb$var$selection_prototype.each,
    on: (0, $fd664209e896113c$export$2e2bcd8739ae039),
    attr: (0, $2a651cfc4e49b53d$export$2e2bcd8739ae039),
    attrTween: (0, $cad13035adb29669$export$2e2bcd8739ae039),
    style: (0, $d0bf366fdef4c332$export$2e2bcd8739ae039),
    styleTween: (0, $83672080502c9717$export$2e2bcd8739ae039),
    text: (0, $e62b6dd5e7df40e7$export$2e2bcd8739ae039),
    textTween: (0, $64d823b28aa7019a$export$2e2bcd8739ae039),
    remove: (0, $b59e1b517983ad92$export$2e2bcd8739ae039),
    tween: (0, $922feb1dfe9c8dcf$export$2e2bcd8739ae039),
    delay: (0, $09cd57996bd81614$export$2e2bcd8739ae039),
    duration: (0, $9c9f124117d5bf14$export$2e2bcd8739ae039),
    ease: (0, $8ea7852b6976e6d1$export$2e2bcd8739ae039),
    easeVarying: (0, $9d186bb80d60f6c9$export$2e2bcd8739ae039),
    end: (0, $5220ae42feb560ba$export$2e2bcd8739ae039),
    [Symbol.iterator]: $a4d5b9ef4f9cfabb$var$selection_prototype[Symbol.iterator]
};



function $5b131c7b61a09e82$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $5b131c7b61a09e82$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $5b131c7b61a09e82$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}



var $b5b43281074f9351$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $5b131c7b61a09e82$export$89238d3bc79d3ada)
};
function $b5b43281074f9351$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $b5b43281074f9351$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)) id = name._id, name = name._name;
    else id = (0, $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b)(), (timing = $b5b43281074f9351$var$defaultTiming).time = (0, $e782289d8bd71451$export$461939dd4422153)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $150ba4634a330696$export$2e2bcd8739ae039)(node, name, id, i, group, timing || $b5b43281074f9351$var$inherit(node, id));
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(groups, this._parents, name, id);
}


(0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype.interrupt = (0, $c1dd383074e2630e$export$2e2bcd8739ae039);
(0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype.transition = (0, $b5b43281074f9351$export$2e2bcd8739ae039);







var $4fc3d848825eb4c8$export$2e2bcd8739ae039 = (x)=>()=>x;


function $de0b5bec424cf247$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $48e2d3ac3b9a75ee$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $48e2d3ac3b9a75ee$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


var $5c8970f4694d4107$var$MODE_DRAG = {
    name: "drag"
}, $5c8970f4694d4107$var$MODE_SPACE = {
    name: "space"
}, $5c8970f4694d4107$var$MODE_HANDLE = {
    name: "handle"
}, $5c8970f4694d4107$var$MODE_CENTER = {
    name: "center"
};
const { abs: $5c8970f4694d4107$var$abs, max: $5c8970f4694d4107$var$max, min: $5c8970f4694d4107$var$min } = Math;
function $5c8970f4694d4107$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $5c8970f4694d4107$var$number2(e) {
    return [
        $5c8970f4694d4107$var$number1(e[0]),
        $5c8970f4694d4107$var$number1(e[1])
    ];
}
var $5c8970f4694d4107$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($5c8970f4694d4107$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $5c8970f4694d4107$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($5c8970f4694d4107$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $5c8970f4694d4107$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($5c8970f4694d4107$var$type),
    input: function(xy) {
        return xy == null ? null : $5c8970f4694d4107$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $5c8970f4694d4107$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $5c8970f4694d4107$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $5c8970f4694d4107$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $5c8970f4694d4107$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $5c8970f4694d4107$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $5c8970f4694d4107$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $5c8970f4694d4107$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $5c8970f4694d4107$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $5c8970f4694d4107$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $5c8970f4694d4107$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $5c8970f4694d4107$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $5c8970f4694d4107$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $5c8970f4694d4107$export$979ace6c88860aa8() {
    return $5c8970f4694d4107$var$brush($5c8970f4694d4107$var$X);
}
function $5c8970f4694d4107$export$468748b530991c54() {
    return $5c8970f4694d4107$var$brush($5c8970f4694d4107$var$Y);
}
function $5c8970f4694d4107$export$2e2bcd8739ae039() {
    return $5c8970f4694d4107$var$brush($5c8970f4694d4107$var$XY);
}
function $5c8970f4694d4107$var$brush(dim) {
    var extent = $5c8970f4694d4107$var$defaultExtent, filter = $5c8970f4694d4107$var$defaultFilter, touchable = $5c8970f4694d4107$var$defaultTouchable, keys = true, listeners = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $5c8970f4694d4107$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $5c8970f4694d4107$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $5c8970f4694d4107$var$local(this).extent;
            (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $5c8970f4694d4107$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $5c8970f4694d4107$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $5c8970f4694d4107$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection, event) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $8385105b4986daed$export$2e2bcd8739ae039)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start(event).brush(event).end(event);
        });
    };
    brush.clear = function(group, event) {
        brush.move(group, null, event);
    };
    function redraw() {
        var group = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this), selection = $5c8970f4694d4107$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $de0b5bec424cf247$export$2e2bcd8739ae039)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode: mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? $5c8970f4694d4107$var$MODE_DRAG : keys && event.altKey ? $5c8970f4694d4107$var$MODE_CENTER : $5c8970f4694d4107$var$MODE_HANDLE, signX = dim === $5c8970f4694d4107$var$Y ? null : $5c8970f4694d4107$var$signsX[type], signY = dim === $5c8970f4694d4107$var$X ? null : $5c8970f4694d4107$var$signsY[type], state = $5c8970f4694d4107$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, $1be794af963d8372$export$2e2bcd8739ae039)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === $5c8970f4694d4107$var$Y ? W : $5c8970f4694d4107$var$min(pts[0][0], pts[1][0]),
                    n0 = dim === $5c8970f4694d4107$var$X ? N : $5c8970f4694d4107$var$min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === $5c8970f4694d4107$var$Y ? E : $5c8970f4694d4107$var$max(pts[0][0], pts[1][0]),
                    s0 = dim === $5c8970f4694d4107$var$X ? S : $5c8970f4694d4107$var$max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move(event);
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $5c8970f4694d4107$var$cursors[type]);
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $905558291b0c219c$export$2e2bcd8739ae039)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, $1be794af963d8372$export$2e2bcd8739ae039)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if ($5c8970f4694d4107$var$abs(point.cur[0] - point[0]) > $5c8970f4694d4107$var$abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, $48e2d3ac3b9a75ee$export$2e2bcd8739ae039)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $5c8970f4694d4107$var$MODE_SPACE:
                case $5c8970f4694d4107$var$MODE_DRAG:
                    if (signX) dx = $5c8970f4694d4107$var$max(W - w0, $5c8970f4694d4107$var$min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = $5c8970f4694d4107$var$max(N - n0, $5c8970f4694d4107$var$min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $5c8970f4694d4107$var$MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = $5c8970f4694d4107$var$max(W, $5c8970f4694d4107$var$min(E, points[0][0])), e1 = $5c8970f4694d4107$var$max(W, $5c8970f4694d4107$var$min(E, points[1][0])), signX = 1;
                        if (signY) n1 = $5c8970f4694d4107$var$max(N, $5c8970f4694d4107$var$min(S, points[0][1])), s1 = $5c8970f4694d4107$var$max(N, $5c8970f4694d4107$var$min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = $5c8970f4694d4107$var$max(W - w0, $5c8970f4694d4107$var$min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = $5c8970f4694d4107$var$max(W - e0, $5c8970f4694d4107$var$min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = $5c8970f4694d4107$var$max(N - n0, $5c8970f4694d4107$var$min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = $5c8970f4694d4107$var$max(N - s0, $5c8970f4694d4107$var$min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case $5c8970f4694d4107$var$MODE_CENTER:
                    if (signX) w1 = $5c8970f4694d4107$var$max(W, $5c8970f4694d4107$var$min(E, w0 - dx * signX)), e1 = $5c8970f4694d4107$var$max(W, $5c8970f4694d4107$var$min(E, e0 + dx * signX));
                    if (signY) n1 = $5c8970f4694d4107$var$max(N, $5c8970f4694d4107$var$min(S, n0 - dy * signY)), s1 = $5c8970f4694d4107$var$max(N, $5c8970f4694d4107$var$min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $5c8970f4694d4107$var$flipX) overlay.attr("cursor", $5c8970f4694d4107$var$cursors[type = $5c8970f4694d4107$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $5c8970f4694d4107$var$flipY) overlay.attr("cursor", $5c8970f4694d4107$var$cursors[type = $5c8970f4694d4107$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, $48e2d3ac3b9a75ee$export$2e2561858db9bf47)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $905558291b0c219c$export$833237748009e1e1)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $5c8970f4694d4107$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($5c8970f4694d4107$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $5c8970f4694d4107$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $5c8970f4694d4107$var$MODE_CENTER;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $5c8970f4694d4107$var$MODE_HANDLE || mode === $5c8970f4694d4107$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $5c8970f4694d4107$var$MODE_SPACE;
                        overlay.attr("cursor", $5c8970f4694d4107$var$cursors.selection);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $48e2d3ac3b9a75ee$export$2e2bcd8739ae039)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move(event);
                    }
                    break;
                case 18:
                    if (mode === $5c8970f4694d4107$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $5c8970f4694d4107$var$MODE_HANDLE;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $5c8970f4694d4107$var$MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $5c8970f4694d4107$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $5c8970f4694d4107$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $5c8970f4694d4107$var$cursors[type]);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $48e2d3ac3b9a75ee$export$2e2bcd8739ae039)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $5c8970f4694d4107$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $4fc3d848825eb4c8$export$2e2bcd8739ae039)($5c8970f4694d4107$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $4fc3d848825eb4c8$export$2e2bcd8739ae039)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $4fc3d848825eb4c8$export$2e2bcd8739ae039)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}


























function $e5dfdc386da08eff$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)([
        document.querySelectorAll(selector)
    ], [
        document.documentElement
    ]) : new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)([
        (0, $cade2308c136039a$export$2e2bcd8739ae039)(selector)
    ], (0, $28a9f77d63e1ff25$export$e8e78c978b129247));
}









var $e4199827a75856fd$var$epsilon2 = 1e-12;
function $e4199827a75856fd$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $e4199827a75856fd$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $e4199827a75856fd$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $e4199827a75856fd$export$2e2bcd8739ae039 = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $e4199827a75856fd$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $e4199827a75856fd$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $e4199827a75856fd$var$tanh(rho * s + r0) - $e4199827a75856fd$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $e4199827a75856fd$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);




var $4aeb7326706b2467$export$2e2bcd8739ae039 = (x)=>()=>x;


function $7a8a51016481311d$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $a3c1094a2e8782d7$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$a3c1094a2e8782d7$export$563a914cafbdc389.prototype = {
    constructor: $a3c1094a2e8782d7$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $a3c1094a2e8782d7$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $a3c1094a2e8782d7$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $a3c1094a2e8782d7$export$f0954fd7d5368655 = new $a3c1094a2e8782d7$export$563a914cafbdc389(1, 0, 0);
$a3c1094a2e8782d7$export$2e2bcd8739ae039.prototype = $a3c1094a2e8782d7$export$563a914cafbdc389.prototype;
function $a3c1094a2e8782d7$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $a3c1094a2e8782d7$export$f0954fd7d5368655;
    return node.__zoom;
}


function $b2e4663bd9fbfcc1$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $b2e4663bd9fbfcc1$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function $91e02783b8b1c24a$var$defaultFilter(event) {
    return (!event.ctrlKey || event.type === "wheel") && !event.button;
}
function $91e02783b8b1c24a$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $91e02783b8b1c24a$var$defaultTransform() {
    return this.__zoom || (0, $a3c1094a2e8782d7$export$f0954fd7d5368655);
}
function $91e02783b8b1c24a$var$defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function $91e02783b8b1c24a$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $91e02783b8b1c24a$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $91e02783b8b1c24a$export$2e2bcd8739ae039() {
    var filter = $91e02783b8b1c24a$var$defaultFilter, extent = $91e02783b8b1c24a$var$defaultExtent, constrain = $91e02783b8b1c24a$var$defaultConstrain, wheelDelta = $91e02783b8b1c24a$var$defaultWheelDelta, touchable = $91e02783b8b1c24a$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $e4199827a75856fd$export$2e2bcd8739ae039), listeners = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
    function zoom(selection) {
        selection.property("__zoom", $91e02783b8b1c24a$var$defaultTransform).on("wheel.zoom", wheeled, {
            passive: false
        }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point, event) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $91e02783b8b1c24a$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point, event);
        else selection.interrupt().each(function() {
            gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p, event) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p, event);
    };
    zoom.scaleTo = function(selection, k, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p, event);
    };
    zoom.translateBy = function(selection, x, y, event) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        }, null, event);
    };
    zoom.translateTo = function(selection, x, y, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $a3c1094a2e8782d7$export$f0954fd7d5368655).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p, event);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $a3c1094a2e8782d7$export$563a914cafbdc389)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $a3c1094a2e8782d7$export$563a914cafbdc389)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point, event) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).event(event).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).event(event).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $a3c1094a2e8782d7$export$563a914cafbdc389)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.sourceEvent = null;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        event: function(event) {
            if (event) this.sourceEvent = event;
            return this;
        },
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            var d = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $7a8a51016481311d$export$2e2bcd8739ae039)(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
            }), d);
        }
    };
    function wheeled(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this);
            g.start();
        }
        (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned(event, ...args) {
        if (touchending || !filter.apply(this, arguments)) return;
        var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
        (0, $905558291b0c219c$export$2e2bcd8739ae039)(event.view);
        (0, $b2e4663bd9fbfcc1$export$2e2561858db9bf47)(event);
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this);
        g.start();
        function mousemoved(event) {
            (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
            if (!g.moved) {
                var dx = event.clientX - x0, dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped(event) {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $905558291b0c219c$export$833237748009e1e1)(event.view, g.moved);
            (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
            g.event(event).end();
        }
    }
    function dblclicked(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
        (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
        if (duration > 0) (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).transition().duration(duration).call(schedule, t1, p0, event);
        else (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).call(zoom.transform, t1, p0, event);
    }
    function touchstarted(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
        (0, $b2e4663bd9fbfcc1$export$2e2561858db9bf47)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(t, this);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this);
            g.start();
        }
    }
    function touchmoved(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
        (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(t, this);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
        (0, $b2e4663bd9fbfcc1$export$2e2561858db9bf47)(event);
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                t = (0, $1be794af963d8372$export$2e2bcd8739ae039)(t, this);
                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                    var p = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    zoom.tapDistance = function(_) {
        return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
    };
    return zoom;
}








class $9884d3290a5788b1$export$d35baa21dcf5217b {
    constructor(index){
        this.container = document.querySelector(`#cursor-${index}`);
        this.links = document.querySelectorAll(`nav[role="navigation"] a`);
        this.link = this.links[index - 1];
        this.boundsLinks = this.link.getBoundingClientRect();
        this.xStart = this.boundsLinks.left + this.boundsLinks.width / 2;
        this.yStart = this.boundsLinks.top + this.boundsLinks.height / 2;
        this.mouse = {
            x: this.xStart,
            y: this.yStart
        };
        this.pos = {
            x: this.xStart,
            y: this.yStart
        };
        this.diff = {
            x: null,
            y: null
        };
        this.tinyCursor = true;
        this.transitionParticles = false;
        this.cursor = false;
        this.activeLinks();
        this.mousemoveCursor();
        window.addEventListener("resize", (e)=>this.init());
    }
    mousemoveCursor() {
        window.addEventListener((0, $c7997aef068a9f19$export$cfb3ac94d9068950) ? "touchmove" : "mousemove", (e)=>{
            this.updateCoordinates(e);
        }, {
            passive: true
        });
    }
    updateCoordinates(e) {
        if (e.type.match("touch")) {
            this.mouse.x = e.touches[0].clientX;
            this.mouse.y = e.touches[0].clientY;
        } else {
            this.mouse.x = e.clientX;
            this.mouse.y = e.clientY;
        }
    }
    setParamsDiffs() {
        this.diff.x = this.mouse.x - this.pos.x;
        this.diff.y = this.mouse.y - this.pos.y;
        this.pos.x += this.diff.x * this.speed;
        this.pos.y += this.diff.y * this.speed;
    }
    init() {
        this.tinyCursor && this.setParamsCursor();
        this.setParamsParticles();
        this.drawCursor();
    }
    loop() {
        this.setParamsDiffs();
        this.tinyCursor && this.setTinyCursor();
        this.setParticles();
        requestAnimationFrame(()=>this.loop());
    }
    drawCursor() {
        this.widthContainer = window.innerWidth;
        this.heightContainer = window.innerHeight;
        this.container.innerHTML = `<svg
        width="${this.widthContainer}"
        height="${this.heightContainer}"
        viewbox="0 0 ${this.widthContainer} ${this.heightContainer}"
        preserveAspectRatio="${this.preserveAspectRatio || "none"}"
        style="background:${this.backColor || "none"}; cursor:${this.cursor ? "default" : "none"};">
        ${this.gradientParticles ? this.drawGradient() : ""}
        ${this.maskCursor ? this.drawMaskCursor() : this.drawParticles()}
        ${this.drawTinyCursor()}
    </svg>`;
        this.svg = this.container.querySelector("svg");
        this.tinyCursor && (this.nodeCursors = this.container.querySelectorAll(".tiny-cursor circle"));
        this.particles = Array.from(this.container.querySelectorAll(".particles circle"));
        this.sorting === "desc" && this.sortParticles();
        this.points = Array(this.nbrParticles).fill().map((el, i)=>{
            return {
                node: this.particles[i],
                x: this.pos.x,
                y: this.pos.y
            };
        });
    }
    drawTinyCursor() {
        return `${this.tinyCursor ? `<g class="tiny-cursor">
        <circle
          r=${this.radiusCursorBack || 10}
          cx=${this.pos.x}
          cy=${this.pos.y}
          fill="${this.fillCursorBack || "none"}"
          fill-opacity="${this.fillOpacityCursorBack || 1}"
          stroke="${this.strokeColorCursorBack || "none"}"
          stroke-width="${this.strokeWidthCursorBack || 1}"
          stroke-opacity="${this.strokeOpacityCursorBack || 1}"
          style="transform-origin: ${this.pos.x}px ${this.pos.y}px">
        </circle>
        <circle
          r=${this.radiusCursor || 10}
          cx=${this.pos.x}
          cy=${this.pos.y}
          fill="${this.fillCursor || "white"}"
          fill-opacity="${this.fillOpacityCursor || 1}"
          stroke="${this.strokeColorCursor || "none"}"
          stroke-width="${this.strokeWidthCursor || 0}"
          stroke-opacity="${this.strokeOpacityCursor || 1}"
          style="transform-origin: ${this.pos.x}px ${this.pos.y}px">
        </circle>
     </g>` : ""}`;
    }
    setTinyCursor() {
        this.rotate = `rotate(${Math.atan2(this.diff.y, this.diff.x) * 180 / Math.PI}deg)`;
        this.squeeze = Math.min(Math.sqrt(Math.pow(this.diff.x, 2) + Math.pow(this.diff.y, 2)) / this.accelerator, this.maxSqueeze);
        this.scale = `scale(${1 + this.squeeze},${1 - this.squeeze})`;
        for (const [i, tinyCursor] of this.nodeCursors.entries()){
            tinyCursor.setAttribute("cx", this.pos.x);
            tinyCursor.setAttribute("cy", this.pos.y);
            tinyCursor.style.transformOrigin = `${this.pos.x}px ${this.pos.y}px`;
            tinyCursor.style.transform = this.rotate + this.scale;
        }
    }
    drawParticles() {
        return `<g class="particles" filter=${this.filterParticles || "none"}>
      ${(()=>{
            if (this.strokeGradient) return `
          <defs>
            <linearGradient id=${this.strokeGradient.idStrokeGradient} x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stop-color=${this.strokeGradient.color1} />
              <stop offset="100%" stop-color=${this.strokeGradient.color2} />
            </linearGradient>
          </defs>`;
        })()}
      ${Array(this.nbrParticles).fill().map((_, i)=>`<circle
          r="${this.setRadiusParticles(i)}"
          cx=${this.pos.x} cy=${this.pos.y}
          fill="${this.fillParticles || "none"}"
          fill-opacity="${this.fillOpacityParticles || 1}"
          stroke="${this.strokeGradient ? `url(#${this.strokeGradient.idStrokeGradient})` : this.strokeColorParticles}"
          stroke-width="${this.strokeWidthParticles || 0}"
          stroke-opacity="${this.strokeOpacityParticles || 1}"
          id="${i}">
        </circle>`).join("")}
    </g>`;
    }
    setParticles() {
        if (this.transitionParticles) for (const [i, particle] of this.particles.entries()){
            particle.setAttribute("cx", this.pos.x);
            particle.setAttribute("cy", this.pos.y);
            particle.style.transitionProperty = "cx,cy";
            particle.style.transitionDuration = `${this.transitionParticles.duration + i * this.transitionParticles.delay}ms `;
            particle.style.transitionTimingFunction = this.transitionParticles.easing;
        }
        else {
            this.posTrail = {
                x: this.pos.x,
                y: this.pos.y
            };
            for (const [i, point] of this.points.entries()){
                this.nextParticle = this.points[i + 1] || this.points[0];
                point.x = this.posTrail.x;
                point.y = this.posTrail.y;
                point.node.setAttribute("cx", this.posTrail.x);
                point.node.setAttribute("cy", this.posTrail.y);
                this.posTrail.x += (this.nextParticle.x - point.x) * (this.delta || 0.9);
                this.posTrail.y += (this.nextParticle.y - point.y) * (this.delta || 0.9);
            }
        }
    }
    sortParticles() {
        this.particlesD3 = $e5dfdc386da08eff$export$2e2bcd8739ae039(this.particles);
        this.particlesD3.data(this.particlesD3._groups[0].map((particle)=>{
            return Number(particle.id);
        }));
        this.particlesD3.sort($3acd474ceacf8a38$export$2e2bcd8739ae039);
    }
    setRadiusParticles(i) {
        this.radius = null;
        if (this.directionRadius === ">") this.radius = this.radiusStart - i * this.radiusDiff;
        else this.radius = this.radiusStart + i * this.radiusDiff;
        this.radius > 0 ? this.radius = this.radius : this.radius = 0;
        return this.radius;
    }
    diagonalWindow() {
        this.width = window.innerWidth;
        this.height = window.innerHeight;
        return Math.ceil(Math.sqrt(this.width * this.width + this.height * this.height));
    }
    activeLinks() {
        this.activeClass = "active";
        for (const link of this.links)link.classList.remove(this.activeClass);
        this.link.classList.add(this.activeClass);
    }
}


class $98f0105372a07187$export$4dd03905e24db71e extends (0, $9884d3290a5788b1$export$d35baa21dcf5217b) {
    constructor(index){
        super(index);
        this.speed = !(0, $c7997aef068a9f19$export$cfb3ac94d9068950) ? 0.5 : 1;
        this.init();
        this.loop();
    }
    setParamsCursor() {
        this.radiusCursor = 15;
        this.fillCursor = getComputedStyle(document.body).getPropertyValue("--primary");
        this.maxSqueeze = 0.6;
        this.accelerator = 1000;
    }
    setParamsParticles() {
        this.strokeGradient = {
            idStrokeGradient: "gradient",
            color2: getComputedStyle(document.body).getPropertyValue("--primary"),
            color1: getComputedStyle(document.body).getPropertyValue("--secondary")
        };
        this.strokeWidthParticles = 1.5;
        this.strokeOpacityParticles = .15;
        this.radiusDiff = 7;
        this.radiusStart = this.radiusCursor * 3;
        this.nbrParticles = Math.round((this.diagonalWindow() + this.radiusDiff - this.radiusStart) / this.radiusDiff);
        this.transitionParticles = {
            duration: 18,
            delay: !(0, $c7997aef068a9f19$export$cfb3ac94d9068950) ? 4 : 14,
            easing: "linear"
        };
    }
}




class $132f8415655589fc$export$5997a7029fdb2351 extends (0, $9884d3290a5788b1$export$d35baa21dcf5217b) {
    constructor(index){
        super(index);
        this.speed = !(0, $c7997aef068a9f19$export$cfb3ac94d9068950) ? 0.5 : 1;
        this.delta = !(0, $c7997aef068a9f19$export$cfb3ac94d9068950) ? 0.04 : 0.04;
        this.cursor = true;
        this.tinyCursor = false;
        this.init();
        this.loop();
    }
    setParamsParticles() {
        this.nbrParticles = !(0, $c7997aef068a9f19$export$cfb3ac94d9068950) ? 800 : 300;
        this.radiusStart = this.diagonalWindow() / 9;
        this.radiusDiff = 0;
        this.sorting = "desc";
        this.idGradient = "gradient";
        this.fillParticles = `url('#${this.idGradient}')`;
        this.gradientParticles = {
            color1: getComputedStyle(document.body).getPropertyValue("--secondary"),
            color2: getComputedStyle(document.body).getPropertyValue("--primary")
        };
    }
    drawGradient() {
        return `<defs>
      <linearGradient id=${this.idGradient}>
        <stop offset="0%"  stop-color="${this.gradientParticles.color1}" />
        <stop offset="100%" stop-color="${this.gradientParticles.color2}" />
      </linearGradient>
    </defs>`;
    }
}




class $2b365e0388c72360$export$4b74b06c88c24b7c extends (0, $9884d3290a5788b1$export$d35baa21dcf5217b) {
    constructor(index){
        super(index);
        this.speed = !(0, $c7997aef068a9f19$export$cfb3ac94d9068950) ? 0.1 : 1;
        this.init();
        this.loop();
    }
    setParamsCursor() {
        this.radiusCursorBack = 32;
        this.radiusCursor = 16;
        this.strokeColorCursorBack = getComputedStyle(document.body).getPropertyValue("--primary");
        this.fillCursor = getComputedStyle(document.body).getPropertyValue("--primary");
        this.maxSqueeze = 0.1;
        this.accelerator = 1000;
    }
    setParamsParticles() {
        this.strokeGradient = {
            idStrokeGradient: "gradient",
            color2: getComputedStyle(document.body).getPropertyValue("--primary"),
            color1: getComputedStyle(document.body).getPropertyValue("--secondary")
        };
        this.radiusDiff = 1;
        this.strokeWidthParticles = 1;
        this.strokeOpacityParticles = .2;
        this.nbrParticles = !(0, $c7997aef068a9f19$export$cfb3ac94d9068950) ? 120 : 60;
        this.directionRadius = ">";
        this.radiusStart = this.diagonalWindow() / 3;
        this.sorting = "desc";
        this.transitionParticles = {
            duration: !(0, $c7997aef068a9f19$export$cfb3ac94d9068950) ? 20 : 100,
            delay: !(0, $c7997aef068a9f19$export$cfb3ac94d9068950) ? 1 : 4,
            easing: "linear"
        };
    }
}




var $065882e788aac012$exports = {};
$065882e788aac012$exports = new URL("space_desktop.aa59e7f3.mp4", import.meta.url).toString();


var $2e7b78b672a1bfdd$exports = {};
$2e7b78b672a1bfdd$exports = new URL("space_mobile.514c2b3f.mp4", import.meta.url).toString();


var $9b55abe8dad87a8f$exports = {};
$9b55abe8dad87a8f$exports = new URL("cover.577de99a.webp", import.meta.url).toString();


class $c37b59ff6169fac6$export$8fa520953830bca4 extends (0, $9884d3290a5788b1$export$d35baa21dcf5217b) {
    constructor(index){
        super(index);
        this.speed = !(0, $c7997aef068a9f19$export$cfb3ac94d9068950) ? !(0, $c7997aef068a9f19$export$95df08bae54cb4df) ? 0.4 : 0.9 : 1;
        this.delta = !(0, $c7997aef068a9f19$export$cfb3ac94d9068950) ? !(0, $c7997aef068a9f19$export$95df08bae54cb4df) ? 0.15 : 0.05 : 0.2;
        this.videoUrlDesktop = new URL($065882e788aac012$exports);
        this.videoUrlMobile = new URL($2e7b78b672a1bfdd$exports);
        this.posterVideo = new URL($9b55abe8dad87a8f$exports);
        this.init();
        this.loop();
    }
    setParamsCursor() {
        this.radiusCursorBack = 32;
        this.radiusCursor = 16;
        this.strokeColorCursorBack = getComputedStyle(document.body).getPropertyValue("--white");
        this.fillCursor = getComputedStyle(document.body).getPropertyValue("--white");
        this.maxSqueeze = 0.1;
        this.accelerator = 1000;
    }
    setParamsParticles() {
        this.nbrParticles = !(0, $c7997aef068a9f19$export$cfb3ac94d9068950) ? !(0, $c7997aef068a9f19$export$95df08bae54cb4df) ? 120 : 15 : 40;
        this.radiusStart = this.diagonalWindow() / 9;
        this.radiusDiff = 0.2;
        this.directionRadius = ">";
        this.filterBackId = "filter-image-back";
        this.filterCursorId = "filter-image-cursor";
        this.particlesMaskId = "mask-particles";
        this.idMask = "maskGradient";
        this.fillParticles = `url('#${this.idMask}')`;
        this.idCursorFilter = "filter-cursor";
        this.filterParticles = `url('#${this.idCursorFilter}')`;
        this.opacityGrayScale = 0.075;
        this.maskCursor = {
            videoDesktop: this.videoUrlDesktop.href,
            videoMobile: this.videoUrlMobile.href
        };
    }
    drawMaskCursor() {
        return `
    <defs>
      <radialGradient id="${this.idMask}">
        <stop offset="0%" stop-color="#fff"/>
        <stop offset="100%" stop-color="#fff"/>
      </radialGradient>
      <mask id=${this.particlesMaskId}>${this.drawParticles()}</mask>
      ${this.filterImageCursor()}
      ${this.filterImageBack()}
      ${this.filterCursor()}
    </defs>
    ${this.drawVideoOrImage()}`;
    }
    drawVideoOrImage() {
        if (!(0, $c7997aef068a9f19$export$95df08bae54cb4df)) return `
      <foreignObject x="0" y="0" width="100%" height="100%" filter=url(#${this.filterBackId}) style="opacity:${this.opacityGrayScale}">${this.insertVideo()}</foreignObject>
      <g id="maskReveal" mask="url(#${this.particlesMaskId})">
        <foreignObject x="0" y="0" width="100%" height="100%" filter=url(#${this.filterCursorId})>${this.insertVideo()}</foreignObject>
      </g>`;
        else return `
      <image x="0" y="0" height="100%" width="100%" filter=url(#${this.filterBackId}) style="opacity:${this.opacityGrayScale}" xlink:href=${this.posterVideo.href} preserveAspectRatio="xMidYMid slice" />
      <g id="maskReveal" mask="url(#${this.particlesMaskId})">
        <image x="0" y="0" height="100%" width="100%" filter=url(#${this.filterCursorId})  xlink:href=${this.posterVideo.href} preserveAspectRatio="xMidYMid slice" />
      </g>`;
    }
    insertVideo() {
        return `
    <video width="100%" height="100%" controls="false" autoplay loop="true" muted crossorigin=anonymous poster=${this.posterVideo.href}>
      <source src="${!(0, $c7997aef068a9f19$export$cfb3ac94d9068950) ? this.maskCursor.videoDesktop : this.maskCursor.videoMobile}" type="video/mp4" />
    </video>`;
    }
    filterCursor() {
        return `<filter id="${this.idCursorFilter}"><feGaussianBlur in="SourceGraphic" stdDeviation="0" /></filter>`;
    }
    filterImageBack() {
        return `
    <filter id=${this.filterBackId}>
      <feColorMatrix type="matrix" values=".33 .33 .33 0 0
        .33 .33 .33 0 0
        .33 .33 .33 0 0
        0 0 0 1 0">
      </feColorMatrix>
    </filter>`;
    }
    filterImageCursor() {
        return `
    <filter id=${this.filterCursorId} filterUnits="objectBoundingBox" primitiveUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feColorMatrix type="matrix" values=".44 .44 .44 0 0
        .44 .44 .44 0 0
        .44 .44 .44 0 0
        0 0 0 1 0">
      </feColorMatrix>
      <feComponentTransfer color-interpolation-filters="sRGB" result="duotone">
        <feFuncR type="table" tableValues="0.55 0.25"></feFuncR>
        <feFuncG type="table" tableValues="0.06 1"></feFuncG>
        <feFuncB type="table" tableValues="0.93 0.91"></feFuncB>
        <feFuncA type="table" tableValues="0 1"></feFuncA>
      </feComponentTransfer>
    </filter>`;
    }
}


"use strict";
const $35da740d59af89ba$export$ca17b14bf34aba4 = ()=>{
    const index = (0, $c7997aef068a9f19$export$990c0428cbb6d662)();
    switch(index){
        case 1:
            new (0, $98f0105372a07187$export$4dd03905e24db71e)(index);
            break;
        case 2:
            new (0, $132f8415655589fc$export$5997a7029fdb2351)(index);
            break;
        case 3:
            new (0, $2b365e0388c72360$export$4b74b06c88c24b7c)(index);
            break;
        case 4:
            new (0, $c37b59ff6169fac6$export$8fa520953830bca4)(index);
            break;
        default:
    }
};
window.addEventListener("load", async ()=>{
    await (0, $c7997aef068a9f19$export$eab97d15b1788b8d)();
    (0, $aef471fcf281183e$export$3e5bc5e5f78bf2fe)();
});


//# sourceMappingURL=index.f30eb7ee.js.map
